<template>
    <div v-if="isActive" :class="{ 'slot-master-dialog-only': dialogOnly }">


    <!-- <div class="vx-col flex items-center gap-2 pl-6">
    <feather-icon icon="ChevronLeftIcon" svgClasses="h-4 w-4 cursor-pointer" @click="goBack" />
    <p class="text-base text-black font-medium cursor-pointer" @click="goBack">back</p>
  </div> -->
    <div class="slot-master-wrapper" :class="{ 'is-dialog-only': dialogOnly }">


      <div id="booking-list" class="slot-master-container">
        <div button-accept="false" button-cancel="false" :active.sync="isActive"
          class="pl-6 pb-4 sticky-top-actions-slot">
          <div class="mb-4 flex items-center gap-4">

            <vs-button @click="isActive = false" color="dark" type="filled" icon-pack="feather" icon="icon-arrow-left">
              Back </vs-button>

          </div>
        </div>
        <div class="slot-master-content-scrollable">

          <div class="p-6 slot-master-content">
            <div class="vx-row">

              <!-- Left Panel: All Bookings -->
              <div class="vx-col w-full xl:w-2/3 booking-list-col">
                <div class="slot-card p-4 md:p-6 rounded-lg booking-card-container">
                  <div class="booking-sticky-header">


                    <!-- Time Slot Header (shown when slot is selected) -->
                    <div v-if="selectedSlotKey" class="time-slot-header mb-6">
                      <div class="flex items-center justify-between">
                        <div class="flex items-center gap-4">
                          <!-- Back to All Bookings Link -->
                          <div class="flex items-center gap-2 cursor-pointer text-gray-600 hover:text-gray-900"
                            @click="clearAllFilters">
                            <feather-icon icon="ChevronLeftIcon" svgClasses="h-6 w-6" />
                            <p class="text-black" style="font-size:20px;">See All Bookings</p>
                          </div>
                        </div>
                      </div>

                      <!-- Time Slot Display with Visibility Toggle -->
                      <div class="booking-toolbar mt-4">
                        <div class="flex flex-wrap items-center gap-3">
                          <h2 class="text-2xl xl:text-3xl font-bold text-black">{{ formatTime(timeSlot) }}</h2>
                          <button type="button" class="visibility-toggle-btn" :class="{ 'visible': slotVisibility }"
                            @click="toggleSlotVisibility">
                            <feather-icon :icon="slotVisibility ? 'EyeIcon' : 'EyeOffIcon'" svgClasses="h-6 w-6" />
                            <span>{{ slotVisibility ? 'Visible' : 'Hidden' }}</span>
                          </button>
                        </div>

                        <!-- Action Buttons -->
                        <div class="booking-toolbar-actions">
                          <booking-export-button module="service" :build-params="buildExportParams" />
                          <vs-button icon-pack="feather" icon="icon-refresh-ccw" @click="refreshBookingsList"
                            class="mr-2">Refresh</vs-button>
                          <vs-button
                            v-if="canShowAddBooking"
                            type="relief"
                            class="add-booking-btn"
                            @click="openNewBookingModal"
                          >+ Add Booking</vs-button>
                        </div>
                      </div>
                    </div>

                    <!-- Default Header (shown when no slot is selected) -->
                    <div v-else class="booking-toolbar mb-4">
                      <p class="font-bold " style="font-size: 24px; color:#1E1E1E">{{ bookingKindHeading }}</p>
                      <div class="booking-toolbar-actions">
                        <booking-export-button module="service" :build-params="buildExportParams" />
                        <vs-button icon-pack="feather" icon="icon-refresh-ccw" @click="refreshBookingsList"
                          class="mr-2">Refresh</vs-button>
                        <vs-button
                          v-if="canShowAddBooking"
                          type="relief"
                          class="add-booking-btn"
                          @click="openNewBookingModal"
                        >+ Add Booking</vs-button>
                      </div>
                    </div>

                    <!-- Status Tabs -->
                    <div class="sticky-status-tabs">

                      <div class="booking-status-bar mb-4">
                        <div class="status-tabs-row">
                          <button v-for="status in statusTabsWithCounts" :key="status.value" type="button"
                            class="tab-btn" :class="{ active: activeStatus === status.value }"
                            @click="changeStatus(status.value)">
                            {{ status.displayLabel }}
                          </button>
                        </div>

                        <div v-if="activeStatus === 'requires_token'" class="search-input-container">
                          <vs-input icon="icon-search" icon-pack="feather" placeholder="Search Token"
                            v-model="searchQuery" @input="onSearchInput" class="w-full" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Scrollable Booking List -->
                  <div class="booking-list-scrollable">

                    <div v-if="bookingRecords.length > 0" class="flex items-center gap-3 mb-3 text-sm">
                      <!-- <vs-checkbox v-model="selectAll"/>
    <feather-icon icon="RotateCwIcon" svgClasses="h-4 w-4 cursor-pointer" @click="refreshBookings" /> -->
                    </div>
                    <div v-else>
                      <h4 class="flex items-center justify-center py-16">
                        No Records Available
                      </h4>
                    </div>

                    <!-- Booking List -->
                    <div v-if="bookingListLoading" class="py-6 text-center text-sm text-grey">Loading bookings...</div>
                    <div v-else>
                      <div v-if="bookingRecords.length > 0" v-for="item in bookingRecords" :key="item._id"
                        class="booking-item-container">

                        <!-- TOKEN LIST VIEW -->
                        <div v-if="activeStatus === 'requires_token'" class="booking-card token-card-view"
                          :class="{ 'is-new-booking': isHighlightedBooking(item) }">
                          <div class="flex items-center justify-between">

                            <!-- Left: Token & User Info -->
                            <div class="flex flex-col gap-2">
                              <div class="flex items-center gap-3 flex-wrap">
                                <span class=" font-bold text-black" style="color: #2C0146; font-size:20px">Token: {{
                                  item.token_number || 'N/A' }}</span>
                                <span class="tag booking-type-tag">{{ bookingTypeLabel(item) }}</span>
                                <span v-if="item.booking_status === 'Pending'" class="tag new-booking-tag">New</span>
                                <span v-if="isInactiveBooking(item)" class="tag danger">{{ item.booking_status }}</span>
                                <template v-else>
                                  <span class="tag" :class="{
                                    'success': isPaymentPaid(item),
                                    'danger': item.payment_status == 'Failed',
                                    'warning': isPaymentPending(item) || item.payment_status == 'Refunded'
                                  }">{{ paymentTagLabel(item) }}</span>
                                  <span class="tag" :class="{
                                    'success': isPrasadGiven(item),
                                    'warning': !isPrasadGiven(item)
                                  }">{{ isPrasadGiven(item) ? 'Given Prasad' : 'Not Given' }}</span>
                                  <span class="tag" :class="{
                                    'success': item.token_status === 'Completed',
                                    'warning': item.token_status === 'Pending' || !item.token_status
                                  }">{{ item.token_status || 'Pending' }}</span>
                                </template>
                              </div>

                              <h4 class="font-bold text-lg">{{ getBookingUserName(item) }}</h4>

                              <div class="text-gray-600 text-sm flex flex-col gap-1">
                                <span>{{ formatDate(item.booking_date) }}</span>
                                <span v-if="getBookingPhone(item)">{{ getBookingPhone(item) }}</span>
                              </div>
                            </div>

                            <div class="flex flex-col gap-2 items-end">
                              <div class="flex flex-wrap justify-end gap-2">
                                <booking-print-button module="service" :booking="item" />
                                <booking-documents-button module="service" :booking-id="item._id" />
                              </div>
                              <vs-button v-if="canApprovePrasadPayment(item)"
                                color="primary" type="filled"
                                @click="confirmApprovePayment(item)">
                                Payment Received
                              </vs-button>
                              <vs-button v-if="canMarkPrasadGiven(item)"
                                color="success" type="filled"
                                @click="confirmMarkPrasadGiven(item)">
                                Given Prasad
                              </vs-button>
                              <vs-button v-if="!['Completed', 'Rejected', 'Cancelled'].includes(item.booking_status)"
                                color="success" type="filled" icon-pack="feather" icon="icon-check-circle"
                                :disabled="featureFlags.enablePaymentGateway && item.payment_status === 'Pending'"
                                @click="confirmMarkAsDone(item)">
                                Mark as Done
                              </vs-button>
                            </div>

                          </div>
                        </div>

                        <!-- STANDARD VIEW -->
                        <div v-else class="booking-card" :class="{ 'is-new-booking': isHighlightedBooking(item) }">
                          <!-- Top Section: Tags and View Details Button -->
                          <div class="booking-header">
                            <div>
                              <!-- User Name -->
                              <div class="booking-tags">
                                <span class="tag booking-type-tag">{{ bookingTypeLabel(item) }}</span>
                                <span v-if="item.booking_status === 'Pending'" class="tag new-booking-tag">New</span>
                                <span v-if="item.booking_time_slot" class="slot-chip">{{
                                  formatTime(item.booking_time_slot.start_time) }} Slot</span>
                                <span v-if="item.booking_status === 'Rejected'" class="tag danger">Rejected</span>
                                <span v-if="item.booking_status === 'Cancelled'" class="tag danger">Cancelled</span>
                                <span v-if="item.booking_status === 'Completed'" class="tag success">Completed</span>

                                <span
                                  v-if="!isInactiveBooking(item) && item.requested_documents && item.requested_documents.length > 0"
                                  class="tag flex items-center gap-2"
                                  :class="{ success: hasDocsApproved(item), warning: !hasDocsApproved(item) }">
                                  <feather-icon v-if="hasDocsApproved(item)" icon="CheckIcon"
                                    svgClasses="h-6 w-6 text-black" />

                                  {{ hasDocsApproved(item) ? 'Documents Approved' : 'Documents Unapproved' }}
                                </span>
                                <span
                                  v-if="!isInactiveBooking(item)"
                                  class="tag" :class="{
                                  'success': isPaymentPaid(item),
                                  'danger': item.payment_status == 'Failed',
                                  'warning': isPaymentPending(item) || item.payment_status == 'Refunded'
                                }">{{ paymentTagLabel(item) }}</span>

                              </div>
                              <h3 class="user-name capitalize mt-5">{{ getBookingUserName(item) }}</h3>

                            </div>

                            <div class="flex flex-col items-end gap-2">
                            <button class="view_details" type="button" @click.stop="openDetailPanel(item)">
                              <p class="flex items-center text-base">
                                <span class="whitespace-no-wrap">View Details</span>
                                <feather-icon icon="ChevronRightIcon" svgClasses="h-5 w-5 text-black" />
                              </p>
                            </button>
                            <div class="flex flex-wrap justify-end gap-2">
                              <booking-print-button module="service" :booking="item" />
                              <booking-documents-button module="service" :booking-id="item._id" />
                            </div>
                            </div>
                          </div>


                          <!-- Booking Information Grid -->
                          <div class="booking-info-grid">
                            <!-- Sangat ID -->
                            <div v-if="getBookingHandle(item)" class="info-item">
                              <div class="info-label">Sangat ID</div>
                              <div class="info-value-with-icon">
                                <span>{{ getBookingHandle(item) }}</span>
                                <feather-icon icon="CopyIcon" svgClasses="h-6 w-6 copy-icon"
                                  @click="copyToClipboard(getBookingHandle(item))" />
                              </div>
                            </div>

                            <!-- Email -->
                            <div v-if="getBookingEmail(item)" class="info-item">
                              <div class="info-label">Email</div>
                              <div class="info-value-with-icon">
                                <span>{{ getBookingEmail(item) }}</span>
                                <feather-icon icon="CopyIcon" svgClasses="h-6 w-6 copy-icon"
                                  @click="copyToClipboard(getBookingEmail(item))" />
                              </div>
                            </div>

                            <!-- Phone -->
                            <div v-if="getBookingPhone(item)" class="info-item">
                              <div class="info-label">Phone</div>
                              <div class="info-value-with-icons">
                                <span>{{ getBookingPhone(item) }}</span>
                                <feather-icon icon="CopyIcon" svgClasses="h-6 w-6 copy-icon"
                                  @click="copyToClipboard(getBookingPhone(item))" />
                                <feather-icon icon="MessageCircleIcon" svgClasses="h-6 w-6 whatsapp-icon"
                                  @click="openWhatsApp(getBookingPhone(item))" />
                              </div>
                            </div>

                            <!-- Booking Date & Time -->
                            <div class="info-item">
                              <div class="info-label">Booking Date & Time</div>
                              <div class="info-value">{{ formatDate(item.booking_date) }} <template
                                  v-if="item.booking_time_slot && item.booking_time_slot.start_time">
                                  {{ formatTime(item.booking_time_slot.start_time) }}
                                  <template v-if="item.booking_time_slot.end_time">
                                    - {{ formatTime(item.booking_time_slot.end_time) }}
                                  </template>
                                </template></div>
                            </div>

                            <!-- Booking ID -->
                            <div class="info-item">
                              <div class="info-label">Booking ID</div>
                              <div class="info-value-with-icon">
                                <span>{{ item.booking_id }}</span>
                                <feather-icon icon="CopyIcon" svgClasses="h-6 w-6 copy-icon"
                                  @click="copyToClipboard(item.booking_id)" />
                              </div>
                            </div>

                            <!-- Booking ID -->
                            <div
                              v-if="isInactiveBooking(item) && bookingStatusReason(item)"
                              class="info-item">
                              <div class="info-label">{{ item.booking_status == "Cancelled" ? 'Cancellation Reason' :
                                'Rejection Reason' }}</div>
                              <div class="info-value-with-icon">
                                <span>{{ bookingStatusReason(item) }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Loading More Indicator -->
                      <div v-if="isLoadingMore" class="py-6 text-center text-sm text-grey">
                        Loading more bookings...
                      </div>
                      <!-- End of List Indicator -->
                      <div v-else-if="!hasMore && bookingRecords.length > 0" class="py-6 text-center text-sm text-grey">
                        No more records to load
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Right Panel: Slot Master -->
              <div class="vx-col w-full xl:w-1/3 slot-master-col">
                <div class="slot-card rounded-lg">
                  <h4 class="mb-4 font-bold px-6 pt-6" style="font-size:24px; color:#1E1E1E">Slot Master</h4>

                  <!-- Service Dropdown -->
                  <div class="mb-4 px-6 ">
                    <p class="text-lg font-bold mb-2">Service Name</p>
                    <select-2 class="w-full" :name="'service'" placeholder="Select Service" :options="serviceOptions"
                      :multiple="false" :value="selectedService" data-vv-as="Service" @input="onServiceChange" />
                  </div>

                  <!-- Date Picker -->
                  <div class="mb-4 px-6 ">
                    <p class="text-lg font-bold mb-2">Date</p>
                    <flat-pickr :config="configDatePicker" v-model="selectedDate" class="w-full"
                      placeholder="Select date" @on-change="refreshBookings" />
                  </div>

                  <!-- Time Slots -->
                  <div class="px-6 pr-3 pb-6">
                    <p class="text-lg font-bold mb-2">Time Slots</p>
                    <div v-if="isLoadingNewSlots" class="text-sm text-grey">Loading slots...</div>
                    <div v-else-if="!displaySlots.length && !selectedService" class="text-lg text-black font-medium">
                      Please select a service first.</div>
                    <div v-else-if="!displaySlots.length && !selectedDate" class="text-lg text-black font-medium">
                      Please select a date.</div>
                    <div v-else-if="!displaySlots.length && selectedService && selectedDate"
                      class="text-lg text-black font-medium">
                      No slots available for the selected date.</div>

                    <div class="slots-scroll-container">
                      <div class="slots-grid">
                        <button v-for="(slot, i) in displaySlots" :key="i" type="button" class="slot-btn" :class="{
                          'slot-selected': selectedSlotKey === `${slot.start_time}-${slot.end_time}`,
                          'slot-disabled': slot.status !== 'available' && !slot.max_booking_limit_reached && slot.is_visible !== false,
                          'slot-limit-reached': slot.max_booking_limit_reached,
                          'slot-hidden': slot.is_visible === false
                        }"
                          :disabled="slot.status !== 'available' && !slot.max_booking_limit_reached && slot.is_visible !== false"
                          @click="selectSlot(slot)">
                          <feather-icon v-if="slot.is_visible === false" icon="EyeOffIcon" svgClasses="h-6 w-6 mr-2" />
                          {{ formatTime(slot.start_time) }}
                        </button>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Detailed Booking Panel - Full View -->
      <div v-if="showDetailPanel && selectedBooking && !isPanelMinimized" ref="detailOverlay" class="detail-panel-overlay" @click="onDetailOverlayClick">
        <div class="detail-panel-shell" @click.stop>
        <div class="detail-panel">
          <!-- Panel Header -->
          <div class="panel-header">
            <div>
              <div class="flex items-center justify-between pb-5">


                <div class="panel-title">
                  <h3 class="capitalize">{{ getBookingUserName(selectedBooking) }}</h3>
                </div>
                <div class="panel-controls flex items-center gap-3 flex-wrap justify-end">
                  <booking-print-button
                    v-if="selectedBooking"
                    module="service"
                    :booking="selectedBooking" />
                  <booking-documents-button
                    v-if="selectedBooking"
                    module="service"
                    :booking-id="selectedBooking._id" />
                  <feather-icon icon="RotateCwIcon" svgClasses="h-6 w-6 cursor-pointer text-black"
                    @click.stop="refreshBookingDetails" title="Refresh Details" />

                  <feather-icon icon="MinusIcon" svgClasses="h-6 w-6 cursor-pointer text-black"
                    @click.stop="togglePanelMinimize" title="Minimize Panel" />

                  <feather-icon icon="XIcon" svgClasses="h-6 w-6 cursor-pointer text-black"
                    @click.stop="closeDetailPanel" title="Close Panel" />
                </div>

              </div>
              <!-- Booking Summary -->
              <div class="booking-summary">
                <div class="booking-tags">
                  <span class="service-tag">{{ getBookingServiceName(selectedBooking) }} Booking</span>
                  <span v-if="bookingSlotLabel(selectedBooking)" class="slot-chip">{{ bookingSlotLabel(selectedBooking) }} Slot</span>
                  <span class="tag booking-type-tag">{{ bookingTypeLabel(selectedBooking) }}</span>
                  <span v-if="selectedBooking.booking_status === 'Rejected'" class="tag danger">Rejected</span>
                  <span v-if="selectedBooking.booking_status === 'Cancelled'" class="tag danger">Cancelled</span>

                  <span
                    v-if="!isInactiveBooking(selectedBooking) && selectedBooking.requested_documents && selectedBooking.requested_documents.length > 0"
                    class="tag"
                    :class="{ success: hasDocsApproved(selectedBooking), warning: !hasDocsApproved(selectedBooking) }">
                    {{ hasDocsApproved(selectedBooking) ? 'Documents Approved' : 'Documents Unapproved' }}
                  </span>
                  <span
                    v-if="!isInactiveBooking(selectedBooking)"
                    class="tag" :class="{
                    'success': isPaymentPaid(selectedBooking),
                    'danger': selectedBooking.payment_status == 'Failed',
                    'warning': isPaymentPending(selectedBooking) || selectedBooking.payment_status == 'Refunded'
                  }">{{ paymentTagLabel(selectedBooking) }}</span>
                  <span
                    v-if="selectedBooking.requires_token && !isInactiveBooking(selectedBooking)"
                    class="tag" :class="{ success: isPrasadGiven(selectedBooking), warning: !isPrasadGiven(selectedBooking) }">
                    {{ isPrasadGiven(selectedBooking) ? 'Given Prasad' : 'Not Given' }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Panel Content -->
          <div class="panel-content">


            <!-- Contact Information -->
            <div class="contact-info">
              <div v-if="getBookingHandle(selectedBooking)" class="info-row">
                <span class="info-label">Sangat ID:</span>
                <div class="info-value-with-icon">
                  <span>{{ getBookingHandle(selectedBooking) }}</span>
                  <feather-icon icon="CopyIcon" svgClasses="h-6 w-6 copy-icon"
                    @click="copyToClipboard(getBookingHandle(selectedBooking))" />
                </div>
              </div>
              <div v-if="getBookingEmail(selectedBooking)" class="info-row">
                <span class="info-label">Email:</span>
                <div class="info-value-with-icon">
                  <span>{{ getBookingEmail(selectedBooking) }}</span>
                  <feather-icon icon="CopyIcon" svgClasses="h-6 w-6 copy-icon"
                    @click="copyToClipboard(getBookingEmail(selectedBooking))" />
                </div>
              </div>
              <div v-if="getBookingPhone(selectedBooking)" class="info-row">
                <span class="info-label">Phone:</span>
                <div class="info-value-with-icons">
                  <span>{{ getBookingPhone(selectedBooking) }}</span>
                  <feather-icon icon="CopyIcon" svgClasses="h-6 w-6 copy-icon"
                    @click="copyToClipboard(getBookingPhone(selectedBooking))" />
                  <feather-icon icon="MessageCircleIcon" svgClasses="h-6 w-6 whatsapp-icon"
                    @click="openWhatsApp(getBookingPhone(selectedBooking))" />
                </div>
              </div>
              <div class="info-row">
                <span class="info-label">Booking Date & Time:</span>
                <span class="info-value">
                  {{ formatDate(selectedBooking.booking_date) }}
                  <template v-if="selectedBooking.booking_time_slot && selectedBooking.booking_time_slot.start_time">
                    {{ formatTime(selectedBooking.booking_time_slot.start_time) }}
                    <template v-if="selectedBooking.booking_time_slot.end_time">
                      - {{ formatTime(selectedBooking.booking_time_slot.end_time) }}
                    </template>
                  </template>
                </span>
              </div>
              <div v-if="
                selectedBooking.approval_details &&
                (selectedBooking.booking_status === 'Cancelled' ||
                  selectedBooking.booking_status === 'Rejected')
              " class="info-row">
                <span class="info-label">{{ selectedBooking.booking_status == "Cancelled" ? 'Cancellation Reason:' :
                  'Rejection Reason:' }}</span>
                <span class="info-value">
                  {{ selectedBooking.approval_details && selectedBooking.approval_details.rejection_reason }}
                </span>
              </div>
            </div>

            <!-- Duty Assigned To -->
            <div class="duty-assign-section">
              <button
                type="button"
                class="duty-assign-collapse-header duty-assign-section-toggle"
                @click="dutyAssignSectionOpen = !dutyAssignSectionOpen"
              >
                <span class="duty-assign-title">Duty Assigned To</span>
                <span v-if="pendingDutyAssignedUsers.length" class="duty-assign-count-badge">
                  {{ pendingDutyAssignedUsers.length }}
                </span>
                <span v-if="dutyAssignSaving" class="duty-assign-saving-label">Saving…</span>
                <feather-icon
                  :icon="dutyAssignSectionOpen ? 'ChevronUpIcon' : 'ChevronDownIcon'"
                  svgClasses="h-5 w-5 duty-assign-chevron"
                />
              </button>

              <div v-show="dutyAssignSectionOpen" class="duty-assign-body">
                <div
                  v-if="!isInactiveBooking(selectedBooking) && !isBookingClosed"
                  class="duty-assign-editor"
                >
                  <div class="duty-assign-search-row">
                    <vs-input
                      v-model="dutyAssignSearchQuery"
                      class="duty-assign-search-input"
                      placeholder="Search by handle name or mobile number"
                      @keyup.enter="runDutyAssignUserSearch"
                    />
                    <vs-button
                      color="dark"
                      type="filled"
                      class="duty-assign-search-btn"
                      :disabled="!(dutyAssignSearchQuery || '').trim() || dutyAssignSearchLoading"
                      @click="runDutyAssignUserSearch"
                    >
                      {{ dutyAssignSearchLoading ? 'Searching…' : 'Search' }}
                    </vs-button>
                  </div>
                  <div v-if="dutyAssignSearchActive" class="duty-assign-results mt-3">
                    <p v-if="dutyAssignSearchLoading" class="duty-assign-results-empty">Searching users…</p>
                    <p
                      v-else-if="!dutyAssignSearchResults.length"
                      class="duty-assign-results-empty"
                    >
                      No users found for this handle or mobile number.
                    </p>
                    <ul v-else class="duty-assign-results-list">
                      <li
                        v-for="user in dutyAssignSearchResults"
                        :key="user._id"
                        class="duty-assign-result-item"
                        :class="{ 'duty-assign-result-item--selected': isDutyAssignCandidateSelected(user._id) }"
                      >
                        <button
                          type="button"
                          class="duty-assign-result-btn"
                          @click="toggleDutyAssignCandidate(user)"
                        >
                          <span class="duty-assign-result-name">{{ formatDutyAssignResultName(user) }}</span>
                          <span v-if="user.handle_name" class="duty-assign-result-meta">
                            Sangat ID: @{{ user.handle_name }}
                          </span>
                          <span v-if="user.mobile_number" class="duty-assign-result-meta">
                            Mobile: {{ user.mobile_number }}
                          </span>
                        </button>
                        <span
                          v-if="isDutyAssignCandidateSelected(user._id)"
                          class="duty-assign-result-badge"
                        >
                          Added
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div v-if="pendingDutyAssignedUsers.length" class="duty-assign-list">
                  <div v-for="person in pendingDutyAssignedUsers" :key="person._id" class="duty-assign-user-card">
                    <div class="duty-assign-user">
                      <div class="duty-assign-avatar">
                        <img v-if="getDutyUserImage(person)" :src="getDutyUserImage(person)" alt="" />
                        <span v-else class="duty-assign-avatar-fallback">{{ getDutyUserInitials(person) }}</span>
                      </div>
                      <div class="duty-assign-user-meta">
                        <p class="duty-assign-name">{{ getDutyUserDisplayName(person) }}</p>
                        <p v-if="person.handle_name" class="duty-assign-detail">
                          Sangat ID: @{{ person.handle_name }}
                        </p>
                        <p v-if="person.mobile_number" class="duty-assign-detail">
                          Mobile: {{ person.mobile_number }}
                        </p>
                      </div>
                      <button
                        v-if="!isInactiveBooking(selectedBooking) && !isBookingClosed"
                        type="button"
                        class="duty-assign-remove"
                        title="Remove from duty"
                        :disabled="dutyAssignSaving"
                        @click="removeDutyAssignee(person._id)"
                      >
                        <feather-icon icon="XIcon" svgClasses="h-4 w-4" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Documents Section -->
            <div class="documents-section">
              <div class="documents-section-header">
                <h4>Documents</h4>
                <booking-documents-button
                  v-if="selectedBooking"
                  module="service"
                  :booking-id="selectedBooking._id" />
              </div>
              <div class="documents-grid">

                <!-- ================= EXISTING DOCUMENTS ================= -->
                <div v-for="doc in documents" :key="doc.key" class="document-card" :class="[`status-${doc.status}`]">
                  <h5 class="document-title">{{ doc.document_name }}</h5>

                  <div class="flex gap-5 mt-5">

                    <!-- Document Image/Preview -->
                    <div class="document-media" @click="hasDocFiles(doc) && openDocPreview(doc.file_urls)">
                      <img v-if="hasDocFiles(doc)" :src="primaryDocImage(doc)" class="document-image" alt="document" />

                      <div v-else class="document-placeholder">
                        <div class="document-icon">📄</div>
                        <div class="document-text">{{ doc.document_name }}</div>
                      </div>

                      <div v-if="hasDocFiles(doc)" class="doc-overlay-icons">
                        <span v-if="getDocFileCount(doc) > 1" class="doc-multi-count">
                          {{ getDocFileCount(doc) }}
                        </span>

                        <feather-icon icon="Maximize2Icon" svgClasses="h-6 w-6 cursor-pointer"
                          @click.stop="openDocPreview(doc.file_urls)" />
                      </div>

                      <input :ref="`docInput-${doc.key}`" type="file" accept="image/*" multiple class="hidden"
                        @change="onDocFileChange(doc.key, $event)" />
                    </div>

                    <div class="document-card-actions">
                    <!-- Pending -->
                    <div v-if="doc.status === 'pending' && !isBookingClosed" class="document-actions-pending">
                      <button type="button" class="doc-btn accept" :disabled="!hasDocFiles(doc)"
                        @click="setDocumentStatus(doc.key, 'accepted')">
                        Accept
                      </button>
                      <button type="button" class="doc-btn reject" @click="setDocumentStatus(doc.key, 'rejected')">
                        Reject
                      </button>
                    </div>

                    <!-- Accepted -->
                    <div v-else-if="doc.status === 'accepted'" class="document-status-accepted"
                      :class="{ 'disabled-state': isBookingClosed }">
                      <div class="status-accepted-box">
                        <feather-icon icon="CheckIcon" svgClasses="h-6 w-6 text-black" />
                        <span>Accepted</span>
                      </div>
                      <button type="button" class="doc-btn undo" @click="setDocumentStatus(doc.key, 'pending')"
                        :disabled="isBookingClosed">
                        <feather-icon icon="RotateCcwIcon" svgClasses="h-6 w-6 text-black" />
                        Undo
                      </button>
                    </div>

                    <!-- Rejected -->
                    <div v-else-if="doc.status === 'rejected'" class="document-status-rejected"
                      :class="{ 'disabled-state': isBookingClosed }">
                      <div class="status-rejected-box">
                        <feather-icon icon="XIcon" svgClasses="h-6 w-6" />
                        <div class="rejected-content">
                          <span class="rejected-title">Rejected</span>
                          <span class="rejected-message">
                            {{ doc.rejectionReason || 'Incorrect document uploaded.' }}
                          </span>
                        </div>
                      </div>
                      <button type="button" class="doc-btn undo" @click="setDocumentStatus(doc.key, 'pending')"
                        :disabled="isBookingClosed">
                        <feather-icon icon="RotateCcwIcon" svgClasses="h-6 w-6" />
                        Undo
                      </button>
                    </div>

                    <booking-document-download-button
                      v-if="hasDocFiles(doc) && selectedBooking"
                      module="service"
                      :booking-id="selectedBooking._id"
                      :document-id="String(doc._id || doc.key)" />
                    </div>

                  </div>
                </div>

                <!-- ================= REQUESTED DOCUMENTS (SAVED) ================= -->
                <div v-for="(reqDoc, idx) in requestedDocuments" :key="`requested-doc-${idx}`"
                  class="document-card new-document-card" @click="handleRequestedDocCardClick(idx, $event)">
                  <div class="new-document-content">
                    <div class="new-doc-left">
                      <div v-if="!reqDoc.isEditing" class="new-doc-info">
                        <h5 class="document-title">{{ reqDoc.document_name || 'New Document' }}</h5>
                        <p class="new-doc-requirement">{{ reqDoc.isRequired ? 'Required' : 'Optional' }}</p>
                        <p v-if="reqDoc.uploadHint" class="new-doc-hint">{{ reqDoc.uploadHint }}</p>
                      </div>

                      <div v-else class="new-doc-edit-form">
                        <input v-model="reqDoc.document_name" type="text" class="new-doc-input"
                          @keyup.enter="finishEditingRequestedDocument(idx)" />
                        <input v-model="reqDoc.uploadHint" type="text" class="new-doc-input"
                          @keyup.enter="finishEditingRequestedDocument(idx)" @click.stop />
                        <div class="new-doc-radio-group" @click.stop>
                          <label class="radio-label" @click.stop>
                            <input type="radio" :value="true" v-model="reqDoc.isRequired" class="radio-input"
                              @click.stop />
                            <span>Required</span>
                          </label>
                          <label class="radio-label" @click.stop>
                            <input type="radio" :value="false" v-model="reqDoc.isRequired" class="radio-input"
                              @click.stop />
                            <span>Optional</span>
                          </label>
                        </div>
                      </div>

                    </div>

                    <div class="new-doc-actions">
                      <button type="button" class="doc-action-btn edit" @click.stop="editRequestedDocument(idx)">
                        <feather-icon icon="EditIcon" svgClasses="h-6 w-6" />
                        <span>Edit</span>
                      </button>
                      <button type="button" class="doc-action-btn delete" @click.stop="deleteRequestedDocument(idx)">
                        <feather-icon icon="TrashIcon" svgClasses="h-6 w-6" />
                        <span>Delete</span>
                      </button>
                    </div>
                  </div>
                </div>

                <!-- ================= NEW DOCUMENTS (TEMP) ================= -->
                <div v-for="(newDoc, idx) in newDocuments" :key="`new-doc-${idx}`"
                  class="document-card new-document-card" @click="handleNewDocCardClick(idx, $event)">
                  <div class="new-document-content">
                    <div class="new-doc-left">
                      <div v-if="!newDoc.isEditing" class="new-doc-info">
                        <h5 class="document-title">{{ newDoc.document_name || 'New Document' }}</h5>
                        <p class="new-doc-requirement">{{ newDoc.isRequired ? 'Required' : 'Optional' }}</p>
                        <p v-if="newDoc.uploadHint" class="new-doc-hint">{{ newDoc.uploadHint }}</p>
                      </div>

                      <div v-else class="new-doc-edit-form">
                        <input v-model="newDoc.document_name" type="text" class="new-doc-input"
                          @keyup.enter="finishEditingNewDocument(idx)" />
                        <input v-model="newDoc.uploadHint" type="text" class="new-doc-input"
                          @keyup.enter="finishEditingNewDocument(idx)" @click.stop />
                        <div class="new-doc-radio-group" @click.stop>
                          <label class="radio-label" @click.stop>
                            <input type="radio" :value="true" v-model="newDoc.isRequired" class="radio-input"
                              @click.stop />
                            <span>Required</span>
                          </label>
                          <label class="radio-label" @click.stop>
                            <input type="radio" :value="false" v-model="newDoc.isRequired" class="radio-input"
                              @click.stop />
                            <span>Optional</span>
                          </label>
                        </div>
                      </div>

                    </div>

                    <div class="new-doc-actions">
                      <button type="button" class="doc-action-btn edit" @click.stop="editNewDocument(idx)">
                        <feather-icon icon="EditIcon" svgClasses="h-6 w-6" />
                        <span>Edit</span>
                      </button>
                      <button type="button" class="doc-action-btn delete" @click.stop="deleteNewDocument(idx)">
                        <feather-icon icon="TrashIcon" svgClasses="h-6 w-6" />
                        <span>Delete</span>
                      </button>
                    </div>
                  </div>
                </div>

              </div>

              <button v-if="selectedBooking.booking_status === 'Pending'" type="button" class="request-doc-btn-new-booking mt-5" @click="addNewDocument">
                <feather-icon icon="PlusIcon" svgClasses="h-5 w-5" />
                <span>Request New Document</span>
              </button>


              <!-- Save Changes Button -->
              <div v-if="documentsModified" class="save-changes-container-docs">
                <vs-button type="filled" class="save-changes-btn" color="success" @click.stop="saveBookingChanges">
                  Save Changes
                </vs-button>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="action-buttons">
              <vs-button v-if="canApprovePrasadPayment(selectedBooking)"
                color="primary" type="filled" class="action-btn"
                @click="confirmApprovePayment(selectedBooking)">
                Payment Received
              </vs-button>
              <vs-button v-if="canMarkPrasadGiven(selectedBooking)"
                color="success" type="filled" class="action-btn"
                @click="confirmMarkPrasadGiven(selectedBooking)">
                Given Prasad
              </vs-button>
              <div v-if="canShowMarkAsButton" class="status-action-container"
                ref="statusActionRef">
                <vs-button type="border" class="action-btn" @click.stop="toggleStatusMenu">
                  <div class="flex items-center gap-2">
                    <span>

                      <feather-icon icon="ChevronUpIcon" svgClasses="h-6 w-6 " />
                    </span>
                    <span class="whitespace-no-wrap">
                      Mark As

                    </span>
                  </div>
                </vs-button>
                <div v-if="showStatusMenu" class="status-menu" @click.stop>
                  <button
                    v-for="opt in statusMenuOptionsForBooking"
                    :key="opt.value"
                    type="button"
                    class="status-menu-item"
                    :class="{ 'status-menu-item--disabled': opt.disabled }"
                    :disabled="opt.disabled"
                    @click="!opt.disabled && applyStatusChange(opt.value)"
                  >
                    {{ opt.label }}
                  </button>
                </div>
              </div>
              <vs-button type="relief" class="action-btn payment-request-btn"
                v-if="featureFlags.enablePaymentGateway && selectedBooking.booking_status !== 'Cancelled' && selectedBooking.booking_status !== 'Rejected' && selectedBooking.booking_status !== 'Confirmed'"
                @click="openPaymentRequestPanel()">
                <div class="flex items-center gap-2">
                  <span>

                    Set Fees For Payment Request
                    <!-- {{ hasPaymentRequestSent ? 'Send Payment Request' : 'Set Fees For Payment Request' }} -->
                  </span>
                  <span class="mt-2">
                    <feather-icon icon="ChevronRightIcon" svgClasses="h-6 w-6" />

                  </span>
                </div>
              </vs-button>
              <p v-if="!featureFlags.enablePaymentGateway && selectedBooking" class="text-base text-center mt-4 p-4 rounded-lg" style="background:#f0fdf4;border:1px solid #86efac;color:#166534;">
                Reservation only — guest pays at gurudwara.
              </p>
            </div>
          </div>
        </div>

        <div v-if="showDocPreviewModal" class="doc-preview-overlay" @click.stop="closeDocPreviewModal">
          <div class="doc-preview-modal" @click.stop>
            <div class="doc-preview-header">
              <h3>Document Preview</h3>
              <feather-icon icon="XIcon" svgClasses="h-5 w-5 cursor-pointer" @click="closeDocPreviewModal"
                title="Close Preview" />
            </div>
            <div class="doc-preview-content">
              <div v-for="(url, index) in previewImageUrls" :key="index" class="doc-preview-image-container">
                <img :src="url" :alt="`Document ${index + 1}`" class="doc-preview-image" />
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>

      <!-- Payment details Model -->

      <div v-if="featureFlags.enablePaymentGateway && showPaymentRequestPanel" class="detail-panel-overlay" @click="closePaymentRequestPanel">
        <div class="detail-panel" @click.stop>
          <!-- Panel Header -->
          <div class="panel-header">
            <div class="panel-title">
              <div class="flex items-center gap-3">
                <feather-icon icon="ChevronLeftIcon" svgClasses="h-5 w-5 cursor-pointer"
                  @click.stop="closePaymentRequestPanel" title="Back to Details" class="back-icon" />
                <h3 class="capitalize">{{ isNewBookingFlow ? getNewBookingUserName() : getBookingUserName(selectedBooking) }}</h3>
              </div>
            </div>
            <div class="panel-controls">
              <feather-icon icon="RotateCwIcon" svgClasses="h-6 w-6 cursor-pointer text-black"
                @click.stop="refreshBookingDetails" title="Refresh Details" />

              <feather-icon icon="MinusIcon" svgClasses="h-6 w-6 cursor-pointer text-black"
                @click.stop="togglePaymentPanelMinimize" title="Minimize Panel" />

              <feather-icon icon="XIcon" svgClasses="h-6 w-6 cursor-pointer text-black" @click.stop="closeAllPanels"
                title="Close Panel" />
            </div>
          </div>

          <!-- Panel Content -->
          <div class="panel-content">
            <!-- Booking Summary -->
            <div class="booking-summary">
              <div class="booking-tags">
                <span class="service-tag">{{ isNewBookingFlow ? getNewBookingServiceName() :
                  getBookingServiceName(selectedBooking) }} Booking</span>
                <span class="slot-chip">{{ isNewBookingFlow ? getNewBookingSlotTime() :
                  bookingSlotLabel(selectedBooking) }} Slot</span>
                <span v-if="!isNewBookingFlow && selectedBooking.booking_status === 'Rejected'"
                  class="tag danger">Rejected</span>
                <span v-if="!isNewBookingFlow && selectedBooking.booking_status === 'Cancelled'"
                  class="tag danger">Cancelled</span>

                <span
                  v-if="!isNewBookingFlow && !isInactiveBooking(selectedBooking) && selectedBooking.requested_documents && selectedBooking.requested_documents.length > 0"
                  class="tag"
                  :class="{ success: hasDocsApproved(selectedBooking), warning: !hasDocsApproved(selectedBooking) }">
                  {{ hasDocsApproved(selectedBooking) ? 'Documents Approved' : 'Documents Unapproved' }}
                </span>
                <span
                  v-if="!isNewBookingFlow && !isInactiveBooking(selectedBooking)"
                  class="tag" :class="{ success: isPaymentPaid(selectedBooking), warning: !isPaymentPaid(selectedBooking) }">{{ paymentTagLabel(selectedBooking) }}</span>
                <span v-if="isNewBookingFlow" class="tag warning">Pending</span>
              </div>
            </div>

            <vs-divider class="my-4"></vs-divider>

            <p class="mb-5 text-lg font-bold">Confirm service fees for this booking</p>

            <!-- Your Service Charge -->
            <div class="vx-row items-start mb-6">
              <div class="vx-col w-full md:w-2/3">
                <h5 class="mb-2 font-bold">Your Service Charge</h5>
                <p class="text-gray-600 mb-4 text-base">Total amount the user will see on the Sangat App</p>
              </div>
              <div class="vx-col w-full md:w-1/3 flex md:justify-end mt-4 md:mt-0">
                <div class="flex items-center w-full md:w-auto">
                  <span class="px-2 py-3 border border-r-0 rounded-l bg-gray-100 text-sm font-semibold">{{ paymentCurrencyCode }}</span>
                  <span class="px-2 py-3 border border-r-0 bg-gray-50 text-sm font-semibold">{{ paymentCurrencySymbol }}</span>
                  <vs-input type="number" min="0" v-model.number="serviceCharge" class="w-full" />
                </div>
              </div>
            </div>

            <vs-divider></vs-divider>

            <!-- Sangat Platform Fee -->
            <div class="vx-row items-center mb-6">
              <div class="vx-col w-full md:w-2/3">
                <h5 class="mb-2 font-bold">Sangat Platform Fee</h5>
                <div class="flex items-center gap-2">
                  <p class="text-gray-600 text-base">This is the fees that will be deduced per booking</p>
                  <div class="tooltip-wrapper">
                    <feather-icon icon="InfoIcon" :svgClasses="['w-6', 'h-6', 'text-grey-500', 'cursor-pointer']" />
                    <span class="tooltip-text">{{ paymentCurrencySymbol }}{{ calculatedPlatformFee }} ({{ platformFeePercentage }}%) will be
                      deducted
                      from {{ paymentCurrencySymbol }}{{ serviceCharge
                        || 0
                      }}</span>
                  </div>
                </div>
              </div>
              <div class="vx-col w-full md:w-1/3 flex md:justify-end mt-4 md:mt-0">
                <div class="px-4 py-3 text-right text-base text-black font-medium">- {{ paymentCurrencySymbol }} {{
                  calculatedPlatformFee.toFixed(2) }}
                </div>
              </div>
            </div>

            <vs-divider></vs-divider>

            <!-- You'll receive -->
            <div class="vx-row items-center mb-6">
              <div class="vx-col w-full md:w-2/3">
                <h5 class="mb-2 font-bold">You'll receive</h5>
                <div class="flex items-center gap-2">
                  <p class="text-gray-600 text-base">This is the amount you'll receive pre tax deductions</p>
                  <div class="tooltip-wrapper">
                    <feather-icon icon="InfoIcon" :svgClasses="['w-6', 'h-6', 'text-grey-500', 'cursor-pointer']" />
                    <span class="tooltip-text">{{ paymentCurrencySymbol }}{{ netReceiveAmount || 0 }} will be received after <br /> deducting {{ paymentCurrencySymbol }}{{
                      calculatedPlatformFee }} ({{ platformFeePercentage }}% platform fee) from {{ paymentCurrencySymbol }}{{ serviceCharge
                        || 0
                      }}</span>

                  </div>
                </div>
              </div>
              <div class="vx-col w-full md:w-1/3 flex md:justify-end mt-4 md:mt-0">
                <div class="flex items-center w-full md:w-auto">
                  <span class="px-2 py-3 border border-r-0 rounded-l bg-gray-100 text-sm font-semibold">{{ paymentCurrencyCode }}</span>
                  <span class="px-2 py-3 border border-r-0 bg-gray-50 text-sm font-semibold">{{ paymentCurrencySymbol }}</span>
                  <vs-input type="number" min="0" v-model.number="netReceiveAmount" class="w-full" />
                </div>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="action-buttons mt-6">
              <vs-button type="relief" class="action-btn send-payment-btn w-full" color="dark"
                :disabled="!canSetPaymentFees" @click="sendPaymentRequest()">
                <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 mr-2" style="color: #ffffff;" />
                Send Payment Request
              </vs-button>

            </div>
            <p v-if="!canSetPaymentFees" class="text-danger text-base text-center">You can send payment link to customer
              once
              all documents are approved.</p>
          </div>
        </div>
      </div>
    </div>
    <!-- Minimized payment Panel - Popup -->
    <div v-if="featureFlags.enablePaymentGateway && showPaymentRequestPanel && isPanelMinimized" class="minimized-panel">
      <div class="minimized-panel-content">
        <!-- Minimized Header -->
        <div class="minimized-header">
          <div class="minimized-title">
            <h4>{{ getBookingUserName(selectedBooking) }}</h4>
          </div>
          <div class="minimized-controls">
            <feather-icon icon="Maximize2Icon" svgClasses="h-6 w-6 text-black cursor-pointer"
              @click.stop="togglePaymentPanelMinimize" title="Maximize Panel" />
            <feather-icon icon="XIcon" svgClasses="h-6 w-6 text-black cursor-pointer" @click.stop="closeDetailPanel"
              title="Close Panel" />
          </div>
        </div>

        <!-- Minimized Content -->
        <div class="minimized-content">
          <div class="minimized-tags">
            <span class="service-tag">{{ getBookingServiceName(selectedBooking) }} Booking</span>
            <span v-if="bookingSlotLabel(selectedBooking)" class="slot-chip">{{ bookingSlotLabel(selectedBooking) }} Slot</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Minimized Booking Panel - Popup -->
    <div v-if="showDetailPanel && selectedBooking && isPanelMinimized"
      ref="minimizedDetailPanel"
      class="minimized-panel shadow-[0_10px_25px_-5px_rgba(0,0,0,0.2),0_8px_10px_-6px_rgba(0,0,0,0.1)]">
      <div class="minimized-panel-content">
        <!-- Minimized Header -->
        <div class="minimized-header">
          <div class="minimized-title">
            <h4>{{ getBookingUserName(selectedBooking) }}</h4>
          </div>
          <div class="minimized-controls">
            <feather-icon icon="Maximize2Icon" svgClasses="h-6 w-6 text-black cursor-pointer"
              @click.stop="togglePanelMinimize" title="Maximize Panel" />
            <feather-icon icon="XIcon" svgClasses="h-6 w-6 text-black cursor-pointer" @click.stop="closeDetailPanel"
              title="Close Panel" />
          </div>
        </div>

        <!-- Minimized Content -->
        <div class="minimized-content">
          <div class="minimized-tags">
            <span class="service-tag">{{ getBookingServiceName(selectedBooking) }} Booking</span>
            <span v-if="bookingSlotLabel(selectedBooking)" class="slot-chip">{{ bookingSlotLabel(selectedBooking) }} Slot</span>
          </div>
        </div>
      </div>
    </div>

    <!-- New Booking - Right Panel (same layout as info panel) -->
    <div v-if="showNewBookingModal && !isNewBookingMinimized" class="detail-panel-overlay"
      @click="closeNewBookingModal">
      <div class="detail-panel" @click.stop>
        <!-- Panel Header -->
        <div class="panel-header">
          <div class="panel-title">
            <h3>New Service Booking</h3>
          </div>
          <div class="panel-controls">
            <feather-icon icon="MinusIcon" svgClasses="h-6 w-6 text-black cursor-pointer"
              @click.stop="toggleNewBookingMinimize" />
            <feather-icon icon="XIcon" svgClasses="h-6 w-6 text-black cursor-pointer"
              @click.stop="closeNewBookingModal" />
          </div>
        </div>

        <!-- Panel Content -->
        <div class="panel-content">
          <!-- Service -->
          <div class="mb-4">
            <label class="vs-input--label">Service Name</label>
            <select-2 class="w-full" :name="'service'" placeholder="Select Service" :options="serviceOptions"
              :multiple="false" :value="newBooking.serviceId" data-vv-as="Service" @input="(item) => {
                newBooking.serviceId = item && item.value;
                if (!item || !item.value) {
                  newBooking.date = null;
                }
              }" />
          </div>


          <template v-if="!requiresToken">
            <!-- Date -->
            <div class="mb-4">
              <label class="vs-input--label">Date</label>
              <flat-pickr :config="configDatePicker" v-model="newBooking.date" class="w-full"
                placeholder="Select date" />
            </div>

            <!-- Time Slots -->
            <div class="mb-4">
              <label class="vs-input--label mb-2 block">Time Slots</label>
              <div v-if="isLoadingNewSlots" class="text-sm text-grey">Loading slots...</div>
              <div v-else-if="!visibleNewBookingSlots.length && !newBooking.serviceId"
                class="text-lg text-black font-medium">
                Please select a service first.</div>
              <div v-else-if="!visibleNewBookingSlots.length && !newBooking.date"
                class="text-lg text-black font-medium">
                Please select a date.</div>

              <div v-else-if="!visibleNewBookingSlots.length && newBooking.serviceId && newBooking.date"
                class="text-lg text-black font-medium"> No slots available for the selected date.</div>
              <div class="slots-grid">

                <button v-for="(slot, i) in visibleNewBookingSlots" :key="i" type="button" class="slot-btn" :class="{
                  'slot-selected': newBooking.selectedSlotKey === `${slot.start_time}-${slot.end_time}`,
                  'slot-disabled': slot.status !== 'available' && !slot.max_booking_limit_reached,
                  'slot-limit-reached': slot.max_booking_limit_reached === true
                }" :disabled="slot.status !== 'available' && slot.max_booking_limit_reached"
                  @click="selectNewBookingSlot(slot)">
                  {{ formatTime(slot.start_time) }}
                </button>
              </div>
            </div>
          </template>


          <!-- Select User -->

          <div class="py-6" style="border-top: 1px solid #d1d5db; border-bottom: 1px solid #d1d5db;">
            <p class="text-2xl text-black font-bold pb-2">Booking For:</p>
            <label class="vs-input--label">Enter Sangat User Handle Name *</label>
            <select-2 class="w-full" :name="'user'" placeholder="Enter Sangat User Handle Name here"
              :options="userOptions" :multiple="false" :value="newBooking.userId" data-vv-as="User"
              @input="(item) => (newBooking.userId = item && item.value)" />
          </div>

          <template v-if="requiresToken && featureFlags.enablePaymentGateway">
            <!-- Payment Options (Requires Token Flow) -->
            <div class="mb-4">
              <label class="vs-input--label mb-2.5">Select Payment Amount Option</label>
              <div class="flex flex-wrap gap-5 mb-4">
                <button v-for="amount in paymentAmounts" :key="amount" type="button" style="font-size:18px;"
                  class="px-5 py-4 border rounded-lg cursor-pointer transition-all duration-200"
                  :class="{ 'bg-black text-white border-black': newBooking.paymentOption === amount, 'bg-white text-black border-gray-300 hover:border-gray-500': newBooking.paymentOption !== amount }"
                  @click="newBooking.paymentOption = amount; newBooking.customAmount = null">
                  Rs. {{ amount }}
                </button>
              </div>

              <!-- Other Amount Button -->
              <div v-if="allowCustomAmount" class="mb-4">
                <button type="button" style="font-size:18px;"
                  class="px-5 py-3 border rounded-lg cursor-pointer transition-all duration-200 "
                  :class="{ 'bg-black text-white border-black': newBooking.paymentOption === 'custom', 'bg-white text-black border-black': newBooking.paymentOption !== 'custom' }"
                  @click="newBooking.paymentOption = 'custom'">
                  Other Amount
                </button>
              </div>

              <!-- Custom Amount Input -->
              <div v-if="newBooking.paymentOption === 'custom'" class="mb-4">
                <label class="vs-input--label">Enter Amount Above Rs.{{ minCustomAmount }}</label>
                <div class="vs-con-input">
                  <input type="number" v-model.number="newBooking.customAmount" class="vs-inputx vs-input--input normal"
                    :min="minCustomAmount" placeholder="Enter amount"
                    style="border: 1px solid rgba(0, 0, 0, 0.2); width: 100%; padding: 0.7rem; border-radius: 5px;" />
                </div>
                <!-- Info Box -->
                <div class="mt-2 p-5 rounded flex items-center gap-2"
                  style="border:1px solid #B432FF; background-color:#F7E9FF; color:#2C0146;">
                  <feather-icon icon="InfoIcon" svgClasses="h-5 w-5" />
                  <span style="font-size:18px;">Entered amount must be at least {{ minCustomAmount }}.</span>
                </div>
              </div>
            </div>
          </template>

          <!-- Collect Documents Toggle -->
          <div v-if="!requiresToken" class="mt-6 mb-4 flex items-center justify-between">
            <h4 class="text-2xl font-bold text-black">Collect Documents?</h4>
            <vs-switch v-model="newBooking.collectDocuments" color="dark" />
          </div>

          <!-- Documents Section -->
          <div v-if="newBooking.collectDocuments && !requiresToken" class="documents-section-new-booking mt-6">
            <h4 class="mb-4 text-lg font-bold text-black">Documents</h4>
            <div class="documents-grid-new-booking">
              <!-- Document Cards -->
              <div v-for="(doc, idx) in newBookingDocuments" :key="`new-booking-doc-${idx}`"
                class="document-card-new-booking" @click="handleNewBookingDocCardClick(idx, $event)">
                <div class="new-document-content">
                  <div class="new-doc-left">
                    <div v-if="!doc.isEditing" class="new-doc-info">
                      <h5 class="document-title">{{ doc.document_name || 'New Document' }}</h5>
                      <p class="new-doc-requirement">{{ doc.isRequired ? 'Required' : 'Optional' }}</p>
                      <p v-if="doc.uploadHint" class="new-doc-hint">{{ doc.uploadHint }}</p>
                    </div>
                    <div v-else class="new-doc-edit-form">
                      <input v-model="doc.document_name" type="text" class="new-doc-input"
                        placeholder="Enter document name" @keyup.enter="finishEditingNewBookingDocument(idx)"
                        :ref="`newBookingDocInput-${idx}`" />
                      <input v-model="doc.uploadHint" type="text" class="new-doc-input"
                        placeholder="Enter upload instructions (e.g., Upload both front and back side together.)"
                        @keyup.enter="finishEditingNewBookingDocument(idx)" @click.stop />
                      <div class="new-doc-radio-group" @click.stop>
                        <label class="radio-label" @click.stop>
                          <input type="radio" :value="true" v-model="doc.isRequired" class="radio-input" @click.stop />
                          <span>Required</span>
                        </label>
                        <label class="radio-label" @click.stop>
                          <input type="radio" :value="false" v-model="doc.isRequired" class="radio-input" @click.stop />
                          <span>Optional</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="new-doc-actions">
                    <button type="button" class="doc-action-btn edit" @click="editNewBookingDocument(idx)">
                      <feather-icon icon="EditIcon" svgClasses="h-6 w-6" />
                      <span>Edit</span>
                    </button>
                    <button type="button" class="doc-action-btn delete" @click="deleteNewBookingDocument(idx)">
                      <feather-icon icon="TrashIcon" svgClasses="h-6 w-6" />
                      <span>Delete</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Request New Document Button -->
            <button type="button" class="request-doc-btn-new-booking" @click="addNewBookingDocument">
              <feather-icon icon="PlusIcon" svgClasses="h-5 w-5" />
              <span>Request New Document</span>
            </button>
          </div>

          <!-- Actions -->
          <div class="nb-actions">
            <vs-button class="action-btn-cta vs-con-loading__container" id="create-booking"
              :disabled="!canSubmitNewBooking" @click="submitNewBooking" color="dark" type="filled" size="large">
              {{ requiresToken && featureFlags.enablePaymentGateway ? 'Send Payment Request' : 'Add Booking' }}
            </vs-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Minimized New Booking Panel - Popup -->
    <div v-if="showNewBookingModal && isNewBookingMinimized" class="minimized-panel">
      <div class="minimized-panel-content">
        <!-- Minimized Header -->
        <div class="minimized-header">
          <div class="minimized-title">
            <h4>New Service Booking</h4>
          </div>
          <div class="minimized-controls">
            <feather-icon icon="Maximize2Icon" svgClasses="h-6 w-6 text-black cursor-pointer"
              @click.stop="toggleNewBookingMinimize" />
            <feather-icon icon="XIcon" svgClasses="h-6 w-6 text-black cursor-pointer"
              @click.stop="closeNewBookingModal" />
          </div>
        </div>

        <!-- Minimized Content -->
        <div class="px-5 py-4">

          <label class="vs-input--label">Service Name</label>
          <select-2 class="w-full" :name="'service'" placeholder="Select Service" :options="serviceOptions"
            :multiple="false" :value="newBooking.serviceId" data-vv-as="Service" @input="(item) => {
              newBooking.serviceId = item && item.value;
              if (!item || !item.value) {
                newBooking.date = null;
              }
            }" />
        </div>
      </div>
    </div>


    <!-- Rejection Reason Dialog -->
    <vs-popup :active.sync="showRejectionDialog"
      :title="`Reason for ${pendingStatusChange === 'Rejected' ? 'Rejection' : 'Cancellation'}`"
      class="rejection-dialog">
      <div class="rejection-dialog-content">
        <p class="mb-4 text-base text-gray-700">
          Please provide a reason for {{ pendingStatusChange === 'Rejected' ? 'rejecting' : 'cancelling' }} this
          booking.
          This reason will be sent to the user via notification.
        </p>
        <vs-textarea v-model="rejectionReason"
          :placeholder="`Enter reason for ${pendingStatusChange === 'Rejected' ? 'rejection' : 'cancellation'}...`"
          rows="5" class="w-full mb-4" />
        <div class="flex justify-end gap-3">
          <vs-button type="border" @click="cancelRejection" color="dark">
            Cancel
          </vs-button>
          <vs-button type="filled" @click="confirmRejection" color="dark">
            Confirm {{ pendingStatusChange === 'Rejected' ? 'Rejection' : 'Cancellation' }}
          </vs-button>
        </div>
      </div>
    </vs-popup>

    <!-- Document Rejection Reason Dialog -->
    <vs-popup :active.sync="showDocRejectionDialog" title="Reason for Document Rejection" class="rejection-dialog">
      <div class="rejection-dialog-content">
        <p class="mb-4 text-base text-gray-700">
          Please provide a reason for rejecting this document.
          This reason will be shown to the user.
        </p>
        <vs-textarea v-model="docRejectionReason" placeholder="Enter reason for document rejection..." rows="5"
          class="w-full mb-4" />
        <div class="flex justify-end gap-3">
          <vs-button type="border" @click="cancelDocRejection" color="dark">
            Cancel
          </vs-button>
          <vs-button type="filled" @click="confirmDocRejection" color="dark">
            Confirm Rejection
          </vs-button>
        </div>
      </div>
    </vs-popup>

  </div>

</template>

<script>
import { mapActions, mapState } from 'vuex'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import moment from 'moment'
import featureFlags from '@/config/featureFlags'
import { calcChargeFromNetReceive, calcNetReceive, calcPlatformFeeAmount } from '@/utils/platformFee'
import { getCurrencySymbol } from '@/utils/currency'
import { isMyGurudwaraPortal, resolveGurudwaraIdFromContext } from '@/utils/portalGurudwara'
import BookingPrintButton from '@/components/booking/BookingPrintButton.vue'
import BookingDocumentsButton from '@/components/booking/BookingDocumentsButton.vue'
import BookingDocumentDownloadButton from '@/components/booking/BookingDocumentDownloadButton.vue'
import BookingExportButton from '@/components/booking/BookingExportButton.vue'

export default {
  name: 'SlotMaster',
  components: { Select2, flatPickr, BookingPrintButton, BookingDocumentsButton, BookingDocumentDownloadButton, BookingExportButton },
  props: {
    showModal: Boolean,
    module_name: String,
    action_name: String,
    overrideGurudwaraId: {
      type: String,
      default: null
    },
    dialogOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      featureFlags,
      selectedService: null,
      selectedDate: null,
      isLoadingSlots: false,
      slots: [],
      displaySlots: [],
      selectedSlotKey: null,
      // bookings
      activeStatus: 'Pending',
      linkedBookingKey: null,
      portalGurudwaraId: null,
      statusTabs: [
        { label: 'Pending', value: 'Pending' },
        { label: 'Confirmed', value: 'Confirmed' },
        { label: 'Rejected', value: 'Rejected' },
        { label: 'Cancelled', value: 'Cancelled' },
        { label: 'Refunded', value: 'Refunded' },
        { label: 'Token List', value: 'requires_token' }
      ],
      selectAll: false,
      configDatePicker: {
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'd / m / Y',
        allowInput: false
      },
      timeSlot: null,
      slotVisibility: true, // Track slot visibility state
      // Detailed view panel state
      selectedBooking: null,
      isPanelMinimized: false,
      showDetailPanel: false,
      showPaymentRequestPanel: false,
      // Scroll lock state
      scrollPosition: undefined,
      // Document review state (per booking session)
      documents: [],
      // Original documents state for tracking changes
      originalDocuments: [],
      // New document requests (temporary, before saving)
      newDocuments: [],
      // Requested documents from booking (saved document requests)
      requestedDocuments: [],
      // Track if documents have been modified
      documentsModified: false,
      highlightedBookingIds: [],
      pendingHighlightId: null,
      highlightTimer: null,
      // Status menu state
      showStatusMenu: false,
      // Rejection reason dialog state
      showRejectionDialog: false,
      pendingStatusChange: null,
      rejectionReason: '',
      // Document rejection reason dialog state
      showDocRejectionDialog: false,
      pendingDocRejection: null,
      docRejectionReason: '',
      serviceCharge: 0,
      platformFeePercentage: 0,
      platformFeeAmount: 0,
      isNewBookingFlow: false, // Flag to indicate if we're in new booking flow
      netReceiveAmount: 0,
      lastEditedField: null, // Track which field was last edited: 'serviceCharge' or 'netReceive'
      // New booking modal state
      showNewBookingModal: false,
      isLoadingNewSlots: false,
      isNewBookingMinimized: false,
      newBooking: {
        serviceId: null,
        date: null,
        selectedSlotKey: null,
        displaySlots: [],
        userId: null,
        collectDocuments: false,
        paymentOption: null,
        customAmount: null
      },
      newBookingDocuments: [],
      // Document preview modal state
      showDocPreviewModal: false,
      previewImageUrls: [],
      // Pagination state for infinite scroll
      currentPage: 1,
      hasMore: true,
      isLoadingMore: false,
      totalResults: 0,
      scrollTimeout: null,
      isUpdatingRecords: false,
      searchQuery: '',
      searchTimeout: null,
      bookingStatusOverrides: {},
      dutyAssignUserIds: [],
      dutyAssignSaving: false,
      dutyAssignUserDetails: {},
      dutyAssignSectionOpen: true,
      dutyAssignSearchQuery: '',
      dutyAssignSearchActive: false,
      dutyAssignActiveSearchTerm: '',
      dutyAssignSearchResults: [],
      dutyAssignSearchLoading: false,
      dutyAssignDraftByBookingId: {}
    }
  },
  computed: {
    ...mapState('service', ['records', 'bookingRecords', 'bookingListLoading', 'createLoading', 'bookingCounts', 'bookingTotal']),
    ...mapState('user', { userRecords: 'records', userListLoading: 'listLoading' }),
    serviceOptions() {
      return (this.records || []).map((s) => ({ label: (s.service && s.service.service_name) || s.service_name, value: s._id }))
    },
    selectedServiceRecord() {
      if (!this.newBooking.serviceId) return null
      return (this.records || []).find(s => s._id === this.newBooking.serviceId)
    },
    paymentCurrencyCode() {
      const gs = this.selectedBooking && this.selectedBooking.gurudwara_service
      if (gs && gs.currency) return gs.currency
      if (this.selectedServiceRecord && this.selectedServiceRecord.currency) {
        return this.selectedServiceRecord.currency
      }
      return 'INR'
    },
    paymentCurrencySymbol() {
      return getCurrencySymbol(this.paymentCurrencyCode)
    },
    requiresToken() {
      const s = this.selectedServiceRecord;
      return !!(s && (s.requires_token || (s.service && s.service.requires_token)));
    },
    paymentAmounts() {
      const s = this.selectedServiceRecord;
      // Check both direct property and nested service property
      const amounts = (s && s.payment_amounts) || (s && s.service && s.service.payment_amounts);
      return Array.isArray(amounts) ? amounts : [];
    },
    allowCustomAmount() {
      const s = this.selectedServiceRecord;
      return !!((s && s.allow_custom_amount) || (s && s.service && s.service.allow_custom_amount));
    },
    minCustomAmount() {
      const s = this.selectedServiceRecord;
      const val = (s && s.min_custom_amount) !== undefined ? s.min_custom_amount : (s && s.service && s.service.min_custom_amount);
      return Number(val) || 0;
    },
    selectedPaymentAmount() {
      if (!this.requiresToken) return 0;
      if (this.newBooking.paymentOption === 'custom') {
        return Number(this.newBooking.customAmount) || 0;
      }
      return Number(this.newBooking.paymentOption) || 0;
    },
    isBookingClosed() {
      if (!this.selectedBooking) return false
      return ['cancelled', 'rejected'].includes((this.selectedBooking.booking_status || '').toLowerCase())
    },
    bookingKindHeading() {
      const labels = {
        prasad: 'Prasad Bookings',
        anandKaraj: 'Anand Karaj Bookings',
        service: 'Service Bookings'
      }
      const kind = this.$route.query && this.$route.query.bookingKind
      return labels[kind] || 'All Bookings'
    },
    canShowMarkAsButton() {
      if (!this.selectedBooking || this.isBookingClosed) return false
      return this.statusMenuOptionsForBooking.length > 0
    },
    statusMenuOptionsForBooking() {
      if (!this.selectedBooking || this.isBookingClosed) return []
      const status = (this.selectedBooking.booking_status || '').toLowerCase()
      if (status === 'pending') {
        const options = [
          { label: 'Reject', value: 'Rejected' },
          { label: 'Cancel', value: 'Cancelled' }
        ]
        if (this.canApprovePendingBooking) {
          options.unshift({ label: 'Approve', value: 'Confirmed' })
        }
        return options
      }
      if (status === 'confirmed') {
        const options = [{ label: 'Cancel', value: 'Cancelled' }]
        if (this.isPaymentPaid(this.selectedBooking)) {
          options.push({ label: 'Mark as Refunded', value: 'Refunded' })
        }
        return options
      }
      return []
    },
    statusTabsWithCounts() {
      const counts = this.bookingCounts || {}
      return this.statusTabs.map((tab) => {
        const keysToCheck = [tab.value, tab.value && tab.value.toLowerCase(), tab.value && tab.value.toUpperCase()]
        let resolvedCount = null
        for (const key of keysToCheck) {
          if (key !== undefined && counts[key] !== undefined) {
            resolvedCount = counts[key]
            break
          }
        }
        const displayLabel = typeof resolvedCount === 'number' ? `${tab.label} (${resolvedCount})` : tab.label
        return { ...tab, displayLabel, count: resolvedCount }
      })
    },
    // Platform fee is always 20% of service charge
    calculatedPlatformFee() {
      return Number(this.platformFeeAmount) || 0
    },
    netReceive() {
      // Return the net receive amount (kept in sync by watchers)
      return Number(this.netReceiveAmount) || 0
    },

    canSetPaymentFees() {
      const charge = Number(this.serviceCharge) || 0
      if (charge <= 0) return false

      if (this.isNewBookingFlow) return true

      // Existing booking: Check document approval status
      if (!this.selectedBooking) return false

      // Use documents array (reflects current UI state) if available, otherwise fall back to uploaded_documents
      const docsToCheck = (this.documents && this.documents.length > 0)
        ? this.documents
        : (this.selectedBooking.uploaded_documents || [])

      // If no documents exist at all, enable the button
      if (!Array.isArray(docsToCheck) || docsToCheck.length === 0) {
        return true
      }

      // Disable if ANY document status is pending
      const hasAnyPending = docsToCheck.some(doc => doc.status === 'pending')
      if (hasAnyPending) {
        return false
      }

      // Check validation
      if (!this.hasDocsApproved(this.selectedBooking)) return false

      // Enable only if all documents are not pending (all are accepted or rejected)
      return true
    },
    // Check if payment request can be sent (all docs approved and fees set)
    canSendPaymentRequest() {
      const charge = Number(this.serviceCharge) || 0
      if (charge <= 0) return false

      if (this.isNewBookingFlow) return true
      if (!this.selectedBooking) return false

      // Check if there are requested documents
      const hasRequestedDocuments = this.selectedBooking.requested_documents &&
        Array.isArray(this.selectedBooking.requested_documents) &&
        this.selectedBooking.requested_documents.length > 0

      // If documents are requested, check uploaded documents
      if (hasRequestedDocuments) {
        // If documents are requested but not uploaded, we might still want to allow payment request
        // The previous logic was blocking it. Let's see:
        // If documents are required (mandatory), we perhaps should block?
        // But usually payment is requested BEFORE documents are fully approved in many flows?
        // User said: "You can send payment link to customer once all documents are approved."
        // This suggests approval IS required.

        const uploadedDocs = this.selectedBooking.uploaded_documents || []
        const isUploadedDocsArray = Array.isArray(uploadedDocs)

        // If requested documents exist but uploaded documents array is blank
        // This means user hasn't uploaded anything yet. 
        // If we want to allow sending payment request even if docs are pending (common in some flows), 
        // we might need to relax this. 
        // However, based on the error message, the requirement IS that documents must be approved.

        // But the user's issue is: "even i off collect document while create booking time... show error"
        // If collect_documents is OFF, then `requested_documents` should be EMPTY.
        // If `requested_documents` is showing up, then the booking somehow has them.
        // BUT, looking at the code for NEW booking submission:
        // We set `collect_documents` in payload only if toggle is ON.

        // Wait, for NEW BOOKING FLOW, `this.selectedBooking` is NULL or stale.
        // This function uses `this.selectedBooking`.
        // If `isNewBookingFlow` is true, we should probably return TRUE.
      }


      if (hasRequestedDocuments) {
        const uploadedDocs = this.selectedBooking.uploaded_documents || []

        // If we have uploaded docs, check their status
        if (Array.isArray(uploadedDocs) && uploadedDocs.length > 0) {
          const allPending = uploadedDocs.every(doc => doc.status === 'pending')
          if (allPending) return false

          // Check validation
          if (!this.hasDocsApproved(this.selectedBooking)) return false
        } else {
          // Requested but no uploads yet. 
          // If we really require approval, then this is false.
          // But if current state is just "Pending", maybe we can't send payment yet?
          // Actually, if NO documents are uploaded, we definitely can't have them approved.
          return false
        }
      }

      const serviceCharge = Number(this.serviceCharge) || 0
      return serviceCharge > 0
    },
    // Check if payment request has already been sent
    hasPaymentRequestSent() {
      if (!this.selectedBooking) return false
      // Check if razorpay_order_id or payment_requested_at exists
      return !!(this.selectedBooking.razorpay_order_id || this.selectedBooking.payment_requested_at)
    },
    userOptions() {
      const users = (Array.isArray(this.userRecords) ? this.userRecords : []).filter(u => u.role && u.role.slug === 'user')
      return users.map((u) => ({
        label: `${(u.first_name || '').trim()} ${(u.last_name || '').trim()}${u.handle_name ? ` (@${u.handle_name})` : ''}`.trim(),
        value: u._id
      }))
    },
    dutyAssignSearchParams() {
      const params = { role_slug: 'user', type: 'dropdown' }
      const term = (this.dutyAssignActiveSearchTerm || '').trim()
      if (term) {
        params.search = term
      }
      return params
    },
    hasDutyAssigned() {
      return (this.dutyAssignUserIds || []).length > 0
    },
    canApprovePendingBooking() {
      if (!this.selectedBooking) return false
      if ((this.selectedBooking.booking_status || '').toLowerCase() !== 'pending') return false
      return this.hasDutyAssigned
    },
    pendingDutyAssignedUsers() {
      const ids = this.dutyAssignUserIds || []
      const seen = new Set()
      const users = []
      ids.forEach((rawId) => {
        const id = String(rawId)
        if (!id || seen.has(id)) return
        seen.add(id)
        const user = this.dutyAssignUserDetails[id] || { _id: id }
        users.push(user)
      })
      return users
    },
    dutyAssignUserOptions() {
      const seen = new Set()
      return this.pendingDutyAssignedUsers.reduce((acc, u) => {
        const id = String(u._id)
        if (seen.has(id)) return acc
        seen.add(id)
        acc.push({
          label: this.formatDutyAssignOptionLabel(u),
          value: u._id
        })
        return acc
      }, [])
    },
    canSubmitNewBooking() {
      if (this.requiresToken) {
        if (!this.newBooking.serviceId || !this.newBooking.userId) return false;
        if (!this.featureFlags.enablePaymentGateway) {
          return true;
        }
        if (this.newBooking.paymentOption === 'custom') {
          return !!(this.newBooking.customAmount && (Number(this.newBooking.customAmount) >= this.minCustomAmount));
        }
        return !!this.newBooking.paymentOption;
      }
      return !!(this.newBooking.serviceId && this.newBooking.date && this.newBooking.selectedSlotKey && this.newBooking.userId)
    },
    visibleNewBookingSlots() {
      // Filter slots to only show visible ones (is_visible !== false)
      return (this.newBooking.displaySlots || []).filter(slot => slot.is_visible !== false)
    },
    isActive: {
      get() {
        return this.showModal
      },
      set(val) {
        this.$emit('update:showModal', val)
      }
    },
    gurudwaraId() {
      return (
        this.portalGurudwaraId
        || resolveGurudwaraIdFromContext(this)
        || null
      )
    },
    canShowAddBooking() {
      return !!this.gurudwaraId || isMyGurudwaraPortal()
    }
  },
  watch: {
    selectedService() {
      this.tryFetchSlots()
    },
    selectedDate() {
      this.tryFetchSlots()
    },
    'newBooking.serviceId'(newServiceId) {
      this.tryFetchNewBookingSlots()
      // Load collect documents from selected service
      if (newServiceId) {
        const selectedService = (this.records || []).find(s => s._id === newServiceId)

        // Set platform fee percentage from master service
        this.platformFeePercentage = selectedService.service.collection_platform_fee || selectedService.collection_platform_fee || 0;

        // Fallback: Calculate percentage from amount and total if 0
        if (!this.platformFeePercentage && selectedService.total_service_amount > 0 && selectedService.platform_fee_amount > 0) {
          this.platformFeePercentage = ((selectedService.platform_fee_amount / selectedService.total_service_amount) * 100).toFixed(2);
          this.platformFeePercentage = parseFloat(this.platformFeePercentage);
        }

        // Amount will be calculated in submit logic or if we want to show it now, we need a base amount.
        // For NEW bookings, payment options are used, so amount isn't fixed yet until selected.
        this.platformFeeAmount = 0; // Will be calculated when amount is known

        // Load collect documents from selected service
        const collectDocuments = selectedService.collect_documents || selectedService.service.collect_documents
        if (selectedService && Array.isArray(collectDocuments) && collectDocuments.length > 0) {
          // Populate documents from service
          this.newBookingDocuments = collectDocuments.map((doc) => ({
            document_name: doc.document_name || doc.name || 'New Document',
            isRequired: doc.is_required !== false,
            uploadHint: doc.description || doc.upload_hint || doc.uploadHint || '',
            isEditing: false
          }))
          // Enable collect documents toggle
          this.newBooking.collectDocuments = true
        } else {
          // Clear documents if service doesn't have collect_documents array
          this.newBookingDocuments = []
          this.newBooking.collectDocuments = false
        }
      } else {
        // Clear documents if no service selected
        this.newBookingDocuments = []
        this.newBooking.collectDocuments = false
        this.platformFeePercentage = 0
        this.platformFeeAmount = 0
      }
    },
    'newBooking.date'() {
      this.tryFetchNewBookingSlots()
    },
    serviceCharge(newVal, oldVal) {
      if (this.lastEditedField === 'netReceive') {
        this.lastEditedField = null
        return
      }
      if (newVal !== null && newVal !== undefined && newVal !== '') {
        this.lastEditedField = 'serviceCharge'
        const charge = Number(newVal) || 0
        this.platformFeeAmount = calcPlatformFeeAmount(charge, this.platformFeePercentage)
        this.netReceiveAmount = calcNetReceive(charge, this.platformFeePercentage)

        this.$nextTick(() => {
          if (this.lastEditedField === 'serviceCharge') {
            this.lastEditedField = null
          }
        })
      }
    },
    netReceiveAmount(newVal, oldVal) {
      if (this.lastEditedField === 'serviceCharge') {
        this.lastEditedField = null
        return
      }
      if (newVal !== null && newVal !== undefined && newVal !== '') {
        this.lastEditedField = 'netReceive'
        const netReceive = Number(newVal) || 0
        this.serviceCharge = calcChargeFromNetReceive(netReceive, this.platformFeePercentage)
        this.platformFeeAmount = calcPlatformFeeAmount(this.serviceCharge, this.platformFeePercentage)

        this.$nextTick(() => {
          if (this.lastEditedField === 'netReceive') {
            this.lastEditedField = null
          }
        })
      }
    },
    '$route.query.open'() {
      this.openLinkedBooking()
    },
    '$route.query.bookingKind'() {
      if (!this.dialogOnly) this.refreshBookings()
    },
    selectAll(val) {
      if (!Array.isArray(this.bookingRecords) || !this.bookingRecords.length) return
      this.bookingRecords.forEach(record => {
        record.selected = val
      })
    },
    createLoading() {
      if (this.createLoading) {
        this.$vs.loading({
          container: '#create-booking',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#create-booking > .con-vs-loading')
      }
    }
  },
  async created() {
    await this.resolvePortalGurudwaraId()
    this.getServices({ page: 1, limit: 100, ...(this.gurudwaraId ? { gurudwara: this.gurudwaraId } : {}) })
    // Preload users for dropdown
    this.getUsers({ page: 1, limit: 100, search: '' })
    if (!this.dialogOnly) {
      this.refreshBookings().then(() => this.openLinkedBooking())
    }
  },
  mounted() {
    if (this.dialogOnly) {
      this.$nextTick(() => this.openNewBookingModal())
    }

    // Add escape key listener
    document.addEventListener('keydown', this.handleEscapeKey)
    // Add scroll listener for infinite scroll
    this.$nextTick(() => {
      const scrollContainer = this.$el.querySelector('.booking-list-scrollable')
      if (scrollContainer) {
        scrollContainer.addEventListener('scroll', this.handleScroll)
      }
    })
    // Commented out - Platform fee is now hardcoded to 20%
    // this.loadPlatformFee()
  },
  beforeDestroy() {
    // Remove escape key listener and ensure scroll is unlocked
    document.removeEventListener('keydown', this.handleEscapeKey)
    // Remove scroll listener
    const scrollContainer = this.$el.querySelector('.booking-list-scrollable')
    if (scrollContainer) {
      scrollContainer.removeEventListener('scroll', this.handleScroll)
    }
    // Clear scroll timeout
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout)
    }
    if (this.highlightTimer) {
      clearTimeout(this.highlightTimer)
      this.highlightTimer = null
    }
    this.unlockBodyScroll()
  },
  methods: {
    ...mapActions('service', { getServices: 'get', getBookings: 'getBookings', updateBookingStatus: 'updateBookingStatus', fetchBookingCountsAction: 'getBookingCounts', updateBooking: 'updateBooking', sendPaymentRequestAction: 'sendPaymentRequest', proceedBookingAction: 'proceedBooking', assignDutyAction: 'assignDuty' }),
    isHighlightedBooking(booking) {
      if (!booking || !booking._id) return false
      return this.highlightedBookingIds.indexOf(booking._id) !== -1
    },
    queueBookingHighlight(bookingId) {
      if (!bookingId) return
      this.pendingHighlightId = bookingId
    },
    applyNewBookingHighlights(list) {
      const bookings = Array.isArray(list) ? list : []
      const now = Date.now()
      const freshWindowMs = 2 * 60 * 1000
      const storageKey = 'sangat_service_seen_booking_ids'
      let seen = []
      try {
        seen = JSON.parse(sessionStorage.getItem(storageKey) || '[]')
      } catch (e) {
        seen = []
      }
      if (!Array.isArray(seen)) seen = []

      const idsToHighlight = []
      if (this.pendingHighlightId) {
        idsToHighlight.push(this.pendingHighlightId)
      }

      bookings.forEach((booking) => {
        if (!booking || !booking._id) return
        const created = booking.createdAt || booking.created_at
        const createdTime = created ? new Date(created).getTime() : 0
        const isFresh = createdTime && (now - createdTime) < freshWindowMs
        const notSeen = seen.indexOf(booking._id) === -1
        if (isFresh && notSeen) {
          idsToHighlight.push(booking._id)
        }
        if (notSeen) {
          seen.push(booking._id)
        }
      })

      if (seen.length > 200) {
        seen = seen.slice(seen.length - 200)
      }
      sessionStorage.setItem(storageKey, JSON.stringify(seen))
      this.pendingHighlightId = null

      const uniqueIds = []
      idsToHighlight.forEach((id) => {
        if (id && uniqueIds.indexOf(id) === -1) uniqueIds.push(id)
      })
      if (!uniqueIds.length) return

      this.highlightedBookingIds = this.highlightedBookingIds.concat(
        uniqueIds.filter((id) => this.highlightedBookingIds.indexOf(id) === -1)
      )
      if (this.highlightTimer) clearTimeout(this.highlightTimer)
      this.highlightTimer = setTimeout(() => {
        this.highlightedBookingIds = this.highlightedBookingIds.filter((id) => uniqueIds.indexOf(id) === -1)
        this.highlightTimer = null
      }, 6000)
    },
    ...mapActions('user', { getUsers: 'get' }),
    bookingDisplayName(booking) {
      if (!booking) return ''
      if (booking.user) {
        return `${booking.user.first_name || ''} ${booking.user.last_name || ''}`.trim()
      }
      return booking.userName || ''
    },
    bookingServiceName(booking) {
      const gurudwaraService = booking && booking.gurudwara_service
      const service = gurudwaraService && gurudwaraService.service
      return (service && service.service_name) || (gurudwaraService && gurudwaraService.service_name) || 'Service'
    },
    bookingSlotLabel(booking) {
      const slot = booking && booking.booking_time_slot
      if (!slot || !slot.start_time) return ''
      return this.formatTime(slot.start_time)
    },
    attachOverlaysToBody() {
      ;['detailOverlay', 'minimizedDetailPanel'].forEach((name) => {
        const el = this.$refs[name]
        if (el && el.parentNode !== document.body) {
          document.body.appendChild(el)
        }
      })
    },
    formatTime(time24) {
      if (!time24) return ''
      // Handle different time formats
      const timeStr = String(time24).trim()
      if (!timeStr) return ''

      // Try specific time formats strictly first for precision
      let parsed = moment(timeStr, ['HH:mm', 'H:mm', 'HH:mm:ss', 'h:mm A', 'hh:mm A'], true)
      if (parsed.isValid()) {
        return parsed.format('h:mm A')
      }

      // Try parsing as a general date/time string (e.g., ISO strings: 2026-01-31T13:37)
      parsed = moment(timeStr)
      if (parsed.isValid()) {
        return parsed.format('h:mm A')
      }

      // If all parsing fails, return the original string as a fallback
      return timeStr
    },

    onServiceChange(item) {
      this.selectedService = item && item.value;
      if (this.selectedService) {
        const selectedService = (this.records || []).find(s => s._id === this.selectedService)
        this.platformFeeAmount = selectedService.service.collection_platform_fee || selectedService.collection_platform_fee || 0;
      }
      this.refreshBookings(); // call your function here
    },
    // Commented out - Platform fee is now hardcoded to 20%
    // async loadPlatformFee(){
    //   try{
    //     const res = await this.$http.get('admin/platform-fee/details')
    //       const data = (res && res.data && res.data.data) || {}
    //       const value =
    //         data.platForm_fee != null ? data.platForm_fee : null
    //       if (value != null) this.platformFeeAmount = Number(value)
    //   }catch(error){
    //     this.$vs.notify({ title: 'Error', text: 'Failed to load platform fee', color: 'danger', position: 'top-center', time: 2500 })
    //   }
    // },
    async refreshBookingsList() {
      try {
        // Show loading indicator
        this.$vs.loading({
          container: '#booking-list',
          scale: 0.6
        })

        // Reset to first page
        // this.page = 1

        // Fetch fresh data
        await this.getBookings({ page: 1, limit: 10, ...(this.gurudwaraId ? { gurudwara: this.gurudwaraId } : {}) })

        this.$vs.notify({
          title: 'Success',
          text: 'Data refreshed successfully',
          color: 'success',
          iconPack: 'feather',
          icon: 'icon-check',
          position: 'top-center'
        })
      } catch (error) {
        console.error('Refresh error:', error)
        this.$vs.notify({
          title: 'Error',
          text: 'Failed to refresh data',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center'
        })
      } finally {
        this.$vs.loading.close('#booking-list > .con-vs-loading')
      }
    },
    async resolvePortalGurudwaraId() {
      let id = resolveGurudwaraIdFromContext(this)
      if (!id) {
        await this.$store.dispatch('adminNotifications/ensureDefaultGurudwaraId')
        id = resolveGurudwaraIdFromContext(this)
      }
      this.portalGurudwaraId = id
    },
    // New Booking Modal handlers
    async openNewBookingModal() {
      if (!this.gurudwaraId) {
        await this.resolvePortalGurudwaraId()
      }
      if (!this.gurudwaraId) {
        this.$vs.notify({
          title: 'Error',
          text: 'Could not determine your gurudwara. Please open bookings from your gurudwara profile.',
          color: 'danger',
          position: 'top-center'
        })
        return
      }
      this.showNewBookingModal = true
      this.lockBodyScroll()
    },
    closeNewBookingModal() {
      this.showNewBookingModal = false
      this.isNewBookingMinimized = false
      this.resetNewBooking()
      this.unlockBodyScroll()
      if (this.dialogOnly && !this.showPaymentRequestPanel) {
        this.isActive = false
      }
    },
    minimizeNewBooking() {
      this.showNewBookingModal = false
    },
    toggleNewBookingMinimize() {
      this.isNewBookingMinimized = !this.isNewBookingMinimized
    },
    resetNewBooking() {
      this.newBooking = {
        serviceId: null,
        date: null,
        selectedSlotKey: null,
        displaySlots: [],
        userId: null,
        collectDocuments: false,
        paymentOption: null, // 'custom' or specific amount value
        customAmount: null
      }
      this.newBookingDocuments = []
      this.serviceCharge = 0
      this.platformFeePercentage = 0
      this.platformFeeAmount = 0
      this.netReceiveAmount = 0
      this.isNewBookingFlow = false
    },
    async tryFetchNewBookingSlots() {
      if (this.requiresToken) return; // Skip fetching slots if token is required

      if (!this.newBooking.serviceId) {
        this.newBooking.date = null
        this.newBooking.displaySlots = []
        return
      }
      if (!this.newBooking.date) return
      this.isLoadingNewSlots = true
      try {
        const { data } = await this.$store.dispatch('service/getAvailableTimeSlots', {
          gurudwara_service_id: this.newBooking.serviceId,
          date: this.newBooking.date
        })
        const slots = data && data.available_slots ? data.available_slots : []
        this.newBooking.displaySlots = this.buildDisplaySlots(data)
        if (!this.newBooking.displaySlots.some(s => `${s.start_time}-${s.end_time}` === this.newBooking.selectedSlotKey)) {
          this.newBooking.selectedSlotKey = null
        }
      } catch (e) {
        const message = e && e.message ? e.message : 'Failed to load time slots'
        this.$vs.notify({ title: 'Error', text: message, color: 'danger', position: 'top-center', time: 4000 })
      } finally {
        this.isLoadingNewSlots = false
      }
    },
    selectNewBookingSlot(slot) {
      // Allow selection of slots with max_booking_limit_reached (they're shown in red but still selectable)
      // Only prevent selection if status is not available and max_booking_limit_reached is false
      if (slot.status !== 'available' && !slot.max_booking_limit_reached) return
      this.newBooking.selectedSlotKey = `${slot.start_time}-${slot.end_time}`
    },
    getSelectedNewBookingService() {
      const serviceId = this.newBooking.serviceId
      if (!serviceId) return null
      return (this.records || []).find((s) => String(s._id) === String(serviceId)) || null
    },
    parseNewBookingSlotTimes() {
      const key = this.newBooking.selectedSlotKey
      if (!key) return { startTime: '', endTime: '' }
      const separatorIndex = String(key).indexOf('-')
      if (separatorIndex === -1) return { startTime: '', endTime: '' }
      return {
        startTime: String(key).slice(0, separatorIndex),
        endTime: String(key).slice(separatorIndex + 1)
      }
    },
    resolveNewBookingSchedule() {
      if (this.requiresToken) {
        return { startTime: '', endTime: '', bookingDateFormatted: null }
      }

      const { startTime, endTime } = this.parseNewBookingSlotTimes()
      if (!startTime || !endTime) {
        return { error: 'Invalid time slot selected' }
      }

      let bookingDateFormatted = null
      if (this.newBooking.date) {
        const dateMoment = moment(this.newBooking.date)
        if (dateMoment.isValid()) {
          bookingDateFormatted = dateMoment.format('YYYY-MM-DD')
        }
      }

      if (!bookingDateFormatted) {
        return { error: 'Please select a valid booking date' }
      }

      return { startTime, endTime, bookingDateFormatted }
    },
    resolveNewBookingAmounts() {
      const selectedServiceData = this.getSelectedNewBookingService()
      const nestedService = selectedServiceData && selectedServiceData.service

      let totalAmountVal = 0
      if (this.requiresToken && this.featureFlags.enablePaymentGateway) {
        totalAmountVal = this.selectedPaymentAmount
      } else if (selectedServiceData) {
        totalAmountVal = Number(selectedServiceData.total_service_amount) || 0
      }

      let feePercentage = 0
      if (nestedService && nestedService.collection_platform_fee != null) {
        feePercentage = Number(nestedService.collection_platform_fee) || 0
      } else if (selectedServiceData && selectedServiceData.collection_platform_fee != null) {
        feePercentage = Number(selectedServiceData.collection_platform_fee) || 0
      } else if (
        selectedServiceData &&
        selectedServiceData.total_service_amount > 0 &&
        selectedServiceData.platform_fee_amount > 0
      ) {
        feePercentage = parseFloat(
          ((selectedServiceData.platform_fee_amount / selectedServiceData.total_service_amount) * 100).toFixed(2)
        )
      }

      const platformFeeVal = calcPlatformFeeAmount(totalAmountVal, feePercentage)
      const serviceAmountVal = calcNetReceive(totalAmountVal, feePercentage)

      return { totalAmountVal, platformFeeVal, serviceAmountVal, feePercentage }
    },
    buildProceedBookingPayload(gurudwaraId, schedule, amounts) {
      const payload = {
        service_id: String(this.newBooking.serviceId),
        gurudwara_id: String(gurudwaraId),
        user_id: String(this.newBooking.userId),
        total_amount: amounts.totalAmountVal,
        platform_fee: amounts.platformFeeVal,
        service_amount: amounts.serviceAmountVal,
        requires_token: this.requiresToken,
        collect_documents: []
      }

      if (schedule.bookingDateFormatted) payload.booking_date = schedule.bookingDateFormatted
      if (schedule.startTime) payload.start_time = schedule.startTime
      if (schedule.endTime) payload.end_time = schedule.endTime

      if (this.newBooking.collectDocuments && this.newBookingDocuments.length > 0) {
        payload.collect_documents = this.newBookingDocuments.map((doc) => ({
          document_name: doc.document_name || 'New Document',
          is_required: doc.isRequired !== false,
          description: doc.uploadHint || ''
        }))
      }

      return payload
    },
    async createReservationBooking(gurudwaraId, schedule, amounts) {
      const payload = this.buildProceedBookingPayload(gurudwaraId, schedule, amounts)

      try {
        this.$vs.loading({ background: 'primary', color: '#fff' })
        const response = await this.proceedBookingAction(payload)
        this.$vs.notify({
          title: 'Success',
          text: response.message || 'Booking created successfully',
          color: 'success',
          position: 'top-center',
          time: 3000
        })
        this.closeNewBookingModal()
        const created = (response && response.data) || {}
        this.queueBookingHighlight(created._id || created.id || (created.booking && created.booking._id))
        this.activeStatus = 'Pending'
        await this.refreshBookings()
      } catch (error) {
        const message = (error && error.message) || 'Failed to create booking'
        this.$vs.notify({
          title: 'Error',
          text: message,
          color: 'danger',
          position: 'top-center',
          time: 4000
        })
      } finally {
        this.$vs.loading.close()
      }
    },
    async submitNewBooking() {
      if (!this.canSubmitNewBooking) return

      const gurudwaraId = this.gurudwaraId
      if (!gurudwaraId) {
        this.$vs.notify({
          title: 'Error',
          text: 'Gurudwara ID not found',
          color: 'danger',
          position: 'top-center',
          time: 3000
        })
        return
      }

      if (!this.newBooking.serviceId || !this.newBooking.userId) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please select service and user',
          color: 'danger',
          position: 'top-center',
          time: 3000
        })
        return
      }

      const schedule = this.resolveNewBookingSchedule()
      if (schedule.error) {
        this.$vs.notify({
          title: 'Error',
          text: schedule.error,
          color: 'danger',
          position: 'top-center',
          time: 3000
        })
        return
      }

      const amounts = this.resolveNewBookingAmounts()
      this.platformFeePercentage = amounts.feePercentage
      this.serviceCharge = amounts.totalAmountVal
      this.platformFeeAmount = amounts.platformFeeVal
      this.netReceiveAmount = amounts.serviceAmountVal

      if (!this.featureFlags.enablePaymentGateway) {
        await this.createReservationBooking(gurudwaraId, schedule, amounts)
        return
      }

      this.isNewBookingFlow = true
      this.showPaymentRequestPanel = true
      this.showNewBookingModal = false
      this.isNewBookingMinimized = false
    },
    onItemSelectChange() {
      if (!Array.isArray(this.bookingRecords) || !this.bookingRecords.length) {
        this.selectAll = false
        return
      }
      this.selectAll = this.bookingRecords.every((b) => !!b.selected)
    },
    formatDate(date) {
      return date ? moment(date).format('DD-MM-YYYY') : '-'
    },
    formatSlotTime(time) {
      return time ? moment(time).format('HH:mm:ss A') : '-'
    },
    async tryFetchSlots() {
      if (!this.selectedService || !this.selectedDate) return
      this.isLoadingSlots = true
      this.slots = []
      this.displaySlots = []
      try {
        const { data } = await this.$store.dispatch('service/getAvailableTimeSlots', {
          gurudwara_service_id: this.selectedService,
          date: this.selectedDate
        })
        this.slots = data && data.available_slots ? data.available_slots : []
        this.displaySlots = this.buildDisplaySlots(data)
      } catch (e) {
        const message = e && e.message ? e.message : 'Failed to load time slots'
        this.$vs.notify({ title: 'Error', text: message, color: 'danger', position: 'top-center', time: 4000 })
      } finally {
        this.isLoadingSlots = false
      }
    },
    buildDisplaySlots(apiData) {
      if (!apiData) return []
      const availableSlots = apiData.available_slots || []

      // If we have slots from API, use them directly (they include all properties like is_visible, status, etc.)
      if (availableSlots.length > 0) {
        return availableSlots.map((slot) => ({
          start_time: slot.start_time,
          end_time: slot.end_time,
          status: slot.status || 'available',
          is_visible: slot.is_visible !== undefined ? slot.is_visible : true,
          max_booking_limit_reached: slot.max_booking_limit_reached || false,
          booking_count: slot.booking_count,
          booking_id: slot.booking_id
        }))
      }

      // Fallback: Build slots from operating hours if API doesn't return slots
      const availableSet = new Set(availableSlots.map((s) => `${s.start_time}-${s.end_time}`))
      const slotMap = new Map()
      availableSlots.forEach((s) => {
        const key = `${s.start_time}-${s.end_time}`
        slotMap.set(key, s)
      })
      const blocks = apiData.operating_hours || []
      const results = []
      for (const block of blocks) {
        let cursor = moment(block.start, 'H:mm')
        const end = moment(block.end, 'H:mm')
        while (cursor.isBefore(end)) {
          const startStr = cursor.format('HH:mm')
          const endStr = cursor.clone().add(30, 'minutes').format('HH:mm')
          if (moment(endStr, 'HH:mm').isAfter(end)) break
          const key = `${startStr}-${endStr}`
          const isAvailable = availableSet.has(key)
          const slotData = slotMap.get(key) || {}
          // Preserve status and is_visible from API if slot exists
          const status = slotData.status || (isAvailable ? 'available' : 'unavailable')
          results.push({
            start_time: startStr,
            end_time: endStr,
            status,
            is_visible: slotData.is_visible !== undefined ? slotData.is_visible : true,
            max_booking_limit_reached: slotData.max_booking_limit_reached || false
          })
          cursor = cursor.add(30, 'minutes')
        }
      }
      return results
    },
    selectSlot(slot) {
      // Allow selecting hidden slots (is_visible === false) - they should be clickable
      if (slot.is_visible === false) {
        // This is a hidden slot, allow selection for toggling visibility
        this.selectedSlotKey = `${slot.start_time}-${slot.end_time}`
        this.timeSlot = slot.start_time
        this.slotVisibility = false
        this.refreshBookings()
        return
      }
      // Allow selecting slots with max_booking_limit_reached (red slots) - they're still selectable
      if (slot.max_booking_limit_reached) {
        this.selectedSlotKey = `${slot.start_time}-${slot.end_time}`
        this.timeSlot = slot.start_time
        this.slotVisibility = slot.is_visible !== false
        this.refreshBookings()
        return
      }
      // For other statuses, only allow available slots
      if (slot.status !== 'available') return
      this.selectedSlotKey = `${slot.start_time}-${slot.end_time}`
      this.timeSlot = slot.start_time
      // Set visibility state based on slot's is_visible property (default to true if not set)
      this.slotVisibility = slot.is_visible !== false
      this.refreshBookings()
    },
    clearAllFilters() {
      // Clear all filters to show all bookings
      this.selectedSlotKey = null
      this.timeSlot = null
      this.selectedDate = null
      this.selectedService = null
      this.activeStatus = 'Pending'
      this.refreshBookings()
    },
    async toggleSlotVisibility() {
      if (!this.selectedService || !this.selectedDate || !this.selectedSlotKey) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please select a service, date, and time slot',
          color: 'warning',
          position: 'top-center',
          time: 3000
        })
        return
      }

      // Extract start_time and end_time from selectedSlotKey (format: "HH:mm-HH:mm")
      const slotTimes = this.selectedSlotKey.split('-')
      const startTime = slotTimes[0] || ''
      const endTime = slotTimes[1] || ''

      if (!startTime || !endTime) {
        this.$vs.notify({
          title: 'Error',
          text: 'Invalid time slot selected',
          color: 'danger',
          position: 'top-center',
          time: 3000
        })
        return
      }

      // Format date as 'YYYY-MM-DD'
      let dateFormatted = null
      if (this.selectedDate) {
        const dateMoment = moment(this.selectedDate)
        if (dateMoment.isValid()) {
          dateFormatted = dateMoment.format('YYYY-MM-DD')
        }
      }

      if (!dateFormatted) {
        this.$vs.notify({
          title: 'Error',
          text: 'Invalid date format',
          color: 'danger',
          position: 'top-center',
          time: 3000
        })
        return
      }

      try {
        // Call the API to toggle slot visibility
        const response = await this.$store.dispatch('service/toggleSlotVisibility', {
          gurudwara_service_id: this.selectedService,
          date: dateFormatted,
          start_time: startTime,
          end_time: endTime
        })

        // Update local visibility state
        this.slotVisibility = response.data.is_visible

        // Show success notification
        this.$vs.notify({
          title: 'Success',
          text: response.message || `Slot ${response.data.is_visible ? 'made visible' : 'hidden'} successfully`,
          color: 'success',
          position: 'top-center',
          time: 3000
        })

        // Refresh slots to reflect the change
        await this.tryFetchSlots()
      } catch (error) {
        const message = error && error.message ? error.message : 'Failed to toggle slot visibility'
        this.$vs.notify({
          title: 'Error',
          text: message,
          color: 'danger',
          position: 'top-center',
          time: 4000
        })
      }
    },
    isUsableUserField(value) {
      if (value == null) return false
      const text = String(value).trim().toLowerCase()
      return text !== '' && text !== 'undefined' && text !== 'null'
    },
    getBookingUserId(booking) {
      if (!booking || booking.user == null) return null
      const user = booking.user
      if (typeof user === 'string' || typeof user === 'number') return String(user)
      return user._id || user.id || null
    },
    resolveBookingUser(booking) {
      if (!booking) return null
      const raw = booking.user
      const looksPopulated = raw && typeof raw === 'object' && (
        this.isUsableUserField(raw.first_name) ||
        this.isUsableUserField(raw.last_name) ||
        this.isUsableUserField(raw.handle_name) ||
        this.isUsableUserField(raw.email) ||
        this.isUsableUserField(raw.mobile_number) ||
        this.isUsableUserField(raw.name)
      )
      if (looksPopulated) return raw

      const userId = this.getBookingUserId(booking)
      if (!userId) return null
      const users = this.userRecords || (this.$store.state.user && this.$store.state.user.records) || []
      return users.find(u => String(u._id) === String(userId)) || null
    },
    formatUserDisplayName(user) {
      if (!user) return ''
      const full = [user.first_name, user.last_name].filter(value => this.isUsableUserField(value)).join(' ').trim()
      if (full) return full
      if (this.isUsableUserField(user.name)) return String(user.name).trim()
      if (this.isUsableUserField(user.handle_name)) {
        return `@${String(user.handle_name).trim().replace(/^@/, '')}`
      }
      if (this.isUsableUserField(user.email)) return String(user.email).trim()
      if (this.isUsableUserField(user.mobile_number)) return String(user.mobile_number).trim()
      return ''
    },
    getBookingUserName(booking) {
      const fromUser = this.formatUserDisplayName(this.resolveBookingUser(booking))
      if (fromUser) return fromUser
      if (booking && this.isUsableUserField(booking.alternate_phone_number)) {
        return String(booking.alternate_phone_number).trim()
      }
      return 'Unknown User'
    },
    getBookingHandle(booking) {
      const user = this.resolveBookingUser(booking)
      return user && this.isUsableUserField(user.handle_name) ? user.handle_name : ''
    },
    getBookingEmail(booking) {
      const user = this.resolveBookingUser(booking)
      return user && this.isUsableUserField(user.email) ? user.email : ''
    },
    getBookingPhone(booking) {
      const user = this.resolveBookingUser(booking)
      if (user && this.isUsableUserField(user.mobile_number)) return user.mobile_number
      if (booking && this.isUsableUserField(booking.alternate_phone_number)) return booking.alternate_phone_number
      return ''
    },
    getBookingServiceName(booking) {
      if (!booking) return 'Service'
      const gs = booking.gurudwara_service
      if (gs && gs.service && gs.service.service_name) return gs.service.service_name
      if (gs && gs.service_name) return gs.service_name
      return 'Service'
    },
    hasDocsApproved(item) {
      if (!item || !Array.isArray(item.uploaded_documents) || item.uploaded_documents.length === 0) {
        return false
      }
      // Check if all uploaded documents have been approved (status === 'accepted')
      return item.uploaded_documents.every(doc => doc.status === 'accepted')
    },
    getUserName(item) {
      // Placeholder until API provides user name
      return (item.user && (item.user.name || item.user.email)) || '—'
    },
    changeStatus(status) {
      this.activeStatus = status
      this.refreshBookings()
    },
    async openLinkedBooking() {
      const bookingId = this.$route.query && this.$route.query.booking
      if (!bookingId || this.dialogOnly) return
      const openKey = `${bookingId}:${this.$route.query.open || ''}`
      if (this.linkedBookingKey === openKey && this.showDetailPanel) return
      this.linkedBookingKey = openKey
      try {
        const res = await this.$http.get('admin/gurudwara-service-booking/list', {
          params: { booking: bookingId, page: 1, limit: 1 }
        })
        const results = res.data && res.data.data && res.data.data.results
        const booking = results && results[0]
        if (!booking) {
          this.$vs.notify({ title: 'Booking', text: 'This service booking could not be opened', color: 'warning', position: 'top-center' })
          return
        }
        const status = booking.requires_token ? 'requires_token' : booking.booking_status
        const known = this.statusTabs.some((tab) => tab.value === status)
        if (known && this.activeStatus !== status) {
          this.changeStatus(status)
        }
        this.openDetailPanel(booking)
      } catch (error) {
        console.error(error)
        this.$vs.notify({ title: 'Booking', text: 'Failed to open this service booking', color: 'danger', position: 'top-center' })
      }
    },
    getBookingOverride(item) {
      if (!item || !item._id) return {}
      return this.bookingStatusOverrides[String(item._id)] || {}
    },
    getEffectivePaymentStatus(item) {
      const override = this.getBookingOverride(item)
      if (Object.prototype.hasOwnProperty.call(override, 'payment_status')) {
        return override.payment_status
      }
      return item && item.payment_status
    },
    getEffectivePrasadStatus(item) {
      const override = this.getBookingOverride(item)
      if (Object.prototype.hasOwnProperty.call(override, 'prasad_status')) {
        return override.prasad_status
      }
      return item && item.prasad_status
    },
    isPaymentPending(item) {
      const status = this.getEffectivePaymentStatus(item)
      return status === 'Pending' || status === 'payment_requested' || !status
    },
    isPaymentPaid(item) {
      return this.getEffectivePaymentStatus(item) === 'Paid'
    },
    isInactiveBooking(item) {
      const status = String((item && item.booking_status) || '').toLowerCase()
      return status === 'rejected' || status === 'cancelled'
    },
    paymentTagLabel(item) {
      if (this.isPaymentPaid(item)) return 'Payment Received'
      const status = this.getEffectivePaymentStatus(item)
      if (status === 'Failed') return 'Failed'
      if (status === 'Refunded') return 'Refunded'
      return 'Pending Payment'
    },
    bookingTypeLabel(item) {
      const name = this.getBookingServiceName(item)
      if (/anand[\s-]*karaj/i.test(name)) return 'Anand Karaj'
      if (/p[ar]+s[hs]?a+d/i.test(name)) return 'Prasad'
      if (item && item.requires_token) return name && name !== 'Service' ? name : 'Token'
      return name || 'Service'
    },
    bookingStatusReason(item) {
      if (!item) return ''
      if (item.status_reason) return item.status_reason
      const approval = item.approval_details || {}
      const cancellation = item.cancellation_details || {}
      if (String(item.booking_status || '').toLowerCase() === 'cancelled') {
        return cancellation.cancellation_reason || approval.rejection_reason || ''
      }
      return approval.rejection_reason || ''
    },
    isPrasadGiven(item) {
      return this.getEffectivePrasadStatus(item) === 'Given'
    },
    isPrasadBookingClosed(item) {
      if (!item) return true
      return ['Rejected', 'Cancelled'].includes(item.booking_status)
    },
    canApprovePrasadPayment(item) {
      if (!item || !item.requires_token || this.isPrasadBookingClosed(item)) return false
      return this.isPaymentPending(item)
    },
    canMarkPrasadGiven(item) {
      if (!item || !item.requires_token || this.isPrasadBookingClosed(item) || this.isPrasadGiven(item)) return false
      return true
    },
    applyPrasadCollectionParams(params) {
      if (this.activeStatus !== 'requires_token') return params
      params.requires_token = true
      delete params.booking_status
      if (this.searchQuery) {
        params.search = this.searchQuery
      }
      return params
    },
    onSearchInput() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.refreshBookings()
      }, 500)
    },
    buildExportParams(scope) {
      const params = {}
      if (this.gurudwaraId) params.gurudwara = this.gurudwaraId
      if (this.selectedService) params.service_id = this.selectedService
      if (this.selectedDate) params.selectedDate = this.selectedDate
      if (this.timeSlot) params.time_slot = this.timeSlot
      if (this.$route.query && this.$route.query.bookingKind) {
        params.booking_kind = this.$route.query.bookingKind
      }
      if (this.activeStatus === 'requires_token') {
        params.requires_token = 'true'
        if (this.searchQuery) params.search = this.searchQuery
      } else if (scope !== 'all') {
        params.booking_status = this.activeStatus
      }
      return params
    },
    async refreshBookings() {
      // Reset pagination when filters change
      this.currentPage = 1
      this.hasMore = true
      this.isLoadingMore = false

      const baseFilters = {}
      const gurudwaraId = this.gurudwaraId
      if (gurudwaraId) baseFilters.gurudwara = gurudwaraId
      if (this.selectedService) baseFilters.service_id = this.selectedService
      if (this.selectedDate) baseFilters.selectedDate = this.selectedDate
      if (this.timeSlot) baseFilters.time_slot = this.timeSlot

      const params = {
        ...baseFilters,
        page: 1,
        limit: 10,
        booking_status: this.activeStatus
      }
      if (this.$route.query && this.$route.query.bookingKind) {
        params.booking_kind = this.$route.query.bookingKind
      }

      this.applyPrasadCollectionParams(params)

      try {
        const response = await this.getBookings(params)
        if (response && response.data) {
          this.totalResults = response.data.totalResults || 0
          // Check if there are more records
          const currentRecordsCount = response.data.results ? response.data.results.length : 0
          this.hasMore = currentRecordsCount < this.totalResults && currentRecordsCount === 10
        }
      } catch (error) {
        // Error handling is done in the store action
        this.hasMore = false
      }
      await this.fetchBookingCounts(baseFilters)
      this.applyBookingStatusOverrides()
      this.applyNewBookingHighlights(this.bookingRecords)
    },
    async loadMoreBookings() {
      // Prevent multiple simultaneous requests
      if (this.isLoadingMore || !this.hasMore || this.bookingListLoading) {
        return
      }

      this.isLoadingMore = true
      const nextPage = this.currentPage + 1

      // IMPORTANT: Get current records BEFORE making API call to preserve them
      const currentRecords = [...(this.bookingRecords || [])]

      const baseFilters = {}
      const gurudwaraId = this.gurudwaraId
      if (gurudwaraId) baseFilters.gurudwara = gurudwaraId
      if (this.selectedService) baseFilters.service_id = this.selectedService
      if (this.selectedDate) baseFilters.selectedDate = this.selectedDate
      if (this.timeSlot) baseFilters.time_slot = this.timeSlot

      const params = {
        ...baseFilters,
        page: nextPage,
        limit: 10,
        booking_status: this.activeStatus
      }
      if (this.$route.query && this.$route.query.bookingKind) {
        params.booking_kind = this.$route.query.bookingKind
      }

      this.applyPrasadCollectionParams(params)

      try {
        // Call API directly to avoid store replacing the records
        const res = await this.$http.get(`admin/gurudwara-service-booking/list`, { params })

        if (res && res.data && res.data.data) {
          const newRecords = res.data.data.results || []

          // Set flag to prevent scroll handler from firing during update
          this.isUpdatingRecords = true

          // Append new records to existing ones (using the preserved currentRecords)
          const updatedRecords = [...currentRecords, ...newRecords]

          // Update store with combined records using Vue.set to ensure reactivity
          this.$store.commit('service/SET_STATE', { action: 'bookingRecords', data: updatedRecords })

          this.currentPage = nextPage
          this.totalResults = res.data.data.totalResults || 0

          // Check if there are more records to load
          // If we got fewer records than the limit, or we've reached the total, there are no more
          this.hasMore = newRecords.length === 10 && updatedRecords.length < this.totalResults

          // Reset flag after DOM update to allow scroll handler again
          this.$nextTick(() => {
            this.isUpdatingRecords = false
          })
        } else {
          this.isUpdatingRecords = false
        }
      } catch (error) {
        this.isUpdatingRecords = false
        console.error('Error loading more bookings:', error)
        this.$vs.notify({
          title: 'Error',
          text: 'Failed to load more bookings',
          color: 'danger',
          position: 'top-center',
          time: 3000
        })
      } finally {
        this.isLoadingMore = false
      }
    },
    handleScroll() {
      // Prevent handling if already loading, updating, or no more records
      if (this.isLoadingMore || !this.hasMore || this.bookingListLoading || this.isUpdatingRecords) {
        return
      }

      // Throttle scroll events to avoid too many calls
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout)
      }

      this.scrollTimeout = setTimeout(() => {
        const scrollContainer = this.$el.querySelector('.booking-list-scrollable')
        if (!scrollContainer) return

        const scrollTop = scrollContainer.scrollTop
        const scrollHeight = scrollContainer.scrollHeight
        const clientHeight = scrollContainer.clientHeight

        // Load more when user scrolls to within 200px of the bottom
        const distanceFromBottom = scrollHeight - scrollTop - clientHeight
        if (distanceFromBottom < 200 && distanceFromBottom > 0) {
          this.loadMoreBookings()
        }
      }, 150)
    },
    async fetchBookingCounts(filters) {
      try {

        await this.fetchBookingCountsAction(filters)
      } catch (error) {
        const message = (error && error.message) || 'Failed to load booking counts'
        this.$vs.notify({
          title: 'Error',
          text: message,
          color: 'danger',
          position: 'top-center',
          time: 3000
        })
      }
    },
    copyToClipboard(text) {

      if (!text) {
        this.$vs.notify({
          title: 'Error',
          text: 'No text to copy',
          color: 'warning',
          position: 'top-center',
          time: 2000
        })
        return
      }

      // Try modern clipboard API first
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
          this.$vs.notify({
            title: 'Copied!',
            text: 'Text copied to clipboard',
            color: 'success',
            position: 'top-center',
            time: 2000
          })
        }).catch((err) => {
          console.error('Clipboard API failed:', err)
          this.fallbackCopy(text)
        })
      } else {
        this.fallbackCopy(text)
      }
    },
    fallbackCopy(text) {
      try {
        const textArea = document.createElement('textarea')
        textArea.value = text
        textArea.style.position = 'fixed'
        textArea.style.left = '-999999px'
        textArea.style.top = '-999999px'
        textArea.style.opacity = '0'
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()

        const successful = document.execCommand('copy')
        document.body.removeChild(textArea)

        if (successful) {
          this.$vs.notify({
            title: 'Copied!',
            text: 'Text copied to clipboard',
            color: 'success',
            position: 'top-center',
            time: 2000
          })
        } else {
          throw new Error('execCommand failed')
        }
      } catch (err) {
        console.error('Fallback copy failed:', err)
        this.$vs.notify({
          title: 'Error',
          text: 'Failed to copy text',
          color: 'danger',
          position: 'top-center',
          time: 2000
        })
      }
    },
    formatDutyAssignOptionLabel(user) {
      if (!user) return ''
      const name = `${(user.first_name || '').trim()} ${(user.last_name || '').trim()}`.trim()
      const handle = user.handle_name ? ` (@${user.handle_name})` : ''
      const mobile = user.mobile_number ? ` · ${user.mobile_number}` : ''
      const base = `${name}${handle}`.trim() || user.handle_name || user.email || 'User'
      return `${base}${mobile}`.trim()
    },
    cacheDutyAssignUsers(users) {
      if (!Array.isArray(users)) return
      users.forEach((u) => {
        if (u && u._id) {
          this.$set(this.dutyAssignUserDetails, String(u._id), { ...u })
        }
      })
    },
    syncDutyAssignForm() {
      if (!this.selectedBooking) return
      const bookingId = String(this.selectedBooking._id)
      const status = (this.selectedBooking.booking_status || '').toLowerCase()

      if (status === 'pending') {
        const draft = this.dutyAssignDraftByBookingId[bookingId]
        if (draft && Array.isArray(draft.ids)) {
          this.dutyAssignUserIds = [...new Set(draft.ids.map((id) => String(id)))]
          if (draft.details && typeof draft.details === 'object') {
            Object.keys(draft.details).forEach((id) => {
              this.$set(this.dutyAssignUserDetails, id, { ...draft.details[id] })
            })
          }
        } else {
          this.dutyAssignUserIds = []
        }
        this.resetDutyAssignSearch()
        return
      }

      const list = this.selectedBooking.duty_assigned_to
      const seen = new Set()
      const users = []
      if (Array.isArray(list)) {
        list.forEach((entry) => {
          if (!entry) return
          let user = null
          if (typeof entry === 'object' && entry._id) {
            user = entry
          } else {
            const id = String(entry._id || entry)
            user = this.dutyAssignUserDetails[id] || { _id: id }
          }
          const id = String(user._id)
          if (!seen.has(id)) {
            seen.add(id)
            users.push(user)
          }
        })
      }
      this.cacheDutyAssignUsers(users)
      this.dutyAssignUserIds = [...new Set(users.map((u) => String(u._id)))]
      this.resetDutyAssignSearch()
    },
    persistDutyAssignDraft() {
      if (!this.selectedBooking) return
      const status = (this.selectedBooking.booking_status || '').toLowerCase()
      if (status !== 'pending') return
      const bookingId = String(this.selectedBooking._id)
      const details = {}
      ;(this.dutyAssignUserIds || []).forEach((rawId) => {
        const id = String(rawId)
        if (this.dutyAssignUserDetails[id]) {
          details[id] = { ...this.dutyAssignUserDetails[id] }
        }
      })
      this.$set(this.dutyAssignDraftByBookingId, bookingId, {
        ids: [...new Set((this.dutyAssignUserIds || []).map((id) => String(id)))],
        details
      })
    },
    clearDutyAssignDraft(bookingId) {
      if (!bookingId) return
      this.$delete(this.dutyAssignDraftByBookingId, String(bookingId))
    },
    resetDutyAssignSearch() {
      this.dutyAssignSearchQuery = ''
      this.dutyAssignSearchActive = false
      this.dutyAssignActiveSearchTerm = ''
      this.dutyAssignSearchResults = []
      this.dutyAssignSearchLoading = false
    },
    normalizeDutyUserRecord(user) {
      if (!user) return null
      const id = user._id || user.value
      if (!id) return null
      return {
        _id: id,
        first_name: user.first_name || '',
        last_name: user.last_name || '',
        handle_name: user.handle_name || '',
        mobile_number: user.mobile_number || '',
        email: user.email || '',
        image: user.image || null
      }
    },
    formatDutyAssignResultName(user) {
      const normalized = this.normalizeDutyUserRecord(user)
      if (!normalized) return 'Unknown user'
      const name = `${normalized.first_name} ${normalized.last_name}`.trim()
      if (name) return name
      if (normalized.handle_name) return `@${normalized.handle_name}`
      if (normalized.mobile_number) return normalized.mobile_number
      return normalized.email || 'Unknown user'
    },
    isDutyAssignCandidateSelected(userId) {
      if (!userId) return false
      return (this.dutyAssignUserIds || []).some((id) => String(id) === String(userId))
    },
    toggleDutyAssignCandidate(user) {
      const normalized = this.normalizeDutyUserRecord(user)
      if (!normalized) return
      const id = String(normalized._id)
      this.$set(this.dutyAssignUserDetails, id, { ...normalized })
      if (this.isDutyAssignCandidateSelected(id)) {
        this.dutyAssignUserIds = this.dutyAssignUserIds.filter((uid) => String(uid) !== id)
      } else {
        this.dutyAssignUserIds = [...new Set([...(this.dutyAssignUserIds || []), id])]
      }
      this.persistDutyAssignDraft()
    },
    async runDutyAssignUserSearch() {
      const term = (this.dutyAssignSearchQuery || '').trim()
      if (!term) return
      this.dutyAssignActiveSearchTerm = term
      this.dutyAssignSearchActive = true
      this.dutyAssignSearchLoading = true
      this.dutyAssignSearchResults = []
      try {
        const res = await this.$http.get('admin/user/portal-list', {
          params: {
            role_slug: 'user',
            search: term,
            limit: 30,
            page: 1
          }
        })
        const results = (res.data && res.data.data && res.data.data.results) || []
        this.dutyAssignSearchResults = results
          .map((row) => this.normalizeDutyUserRecord(row))
          .filter(Boolean)
      } catch (error) {
        this.dutyAssignSearchResults = []
        this.$vs.notify({
          title: 'Search failed',
          text: (error && error.response && error.response.data && error.response.data.message) || 'Could not search users',
          color: 'danger',
          position: 'top-center',
          time: 3000
        })
      } finally {
        this.dutyAssignSearchLoading = false
      }
    },
    dutyAssignIdsKey(ids) {
      return [...new Set((ids || []).map((id) => String(id)))].sort().join(',')
    },
    removeDutyAssignee(userId) {
      if (!userId || this.dutyAssignSaving) return
      this.dutyAssignUserIds = this.dutyAssignUserIds.filter((id) => String(id) !== String(userId))
      this.persistDutyAssignDraft()
    },
    getDutyUserDisplayName(person) {
      if (!person) return ''
      const name = `${person.first_name || ''} ${person.last_name || ''}`.trim()
      if (name) return name
      if (person.handle_name) return `@${person.handle_name}`
      if (person.mobile_number) return person.mobile_number
      return person.email || 'Unknown user'
    },
    getDutyUserInitials(person) {
      const name = this.getDutyUserDisplayName(person)
      if (!name) return '?'
      const parts = name.replace('@', '').split(/\s+/).filter(Boolean)
      if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase()
      return name.slice(0, 2).toUpperCase()
    },
    getDutyUserImage(person) {
      if (!person || !person.image) return null
      if (typeof person.image === 'string' && person.image.startsWith('http')) return person.image
      return person.image
    },
    async saveDutyAssign(options = {}) {
      const { silent = false, notify = false } = options
      if (!this.selectedBooking || !this.selectedBooking._id) return
      this.dutyAssignSaving = true
      try {
        const userIds = [...new Set((this.dutyAssignUserIds || []).map((id) => String(id)))]
        const { data, message } = await this.assignDutyAction({
          bookingId: this.selectedBooking._id,
          user_ids: userIds,
          notify: notify === true
        })
        if (data) {
          const dutyList = Array.isArray(data.duty_assigned_to) ? data.duty_assigned_to : []
          this.cacheDutyAssignUsers(dutyList)
          this.selectedBooking = {
            ...this.selectedBooking,
            ...data,
            duty_assigned_to: dutyList.length ? dutyList : []
          }
          this.patchBookingRecord(this.selectedBooking)
        }
        this.syncDutyAssignForm()
        if (!silent) {
          this.$vs.notify({
            title: 'Success',
            text: message || 'Duty assignees updated',
            color: 'success',
            position: 'top-center',
            time: 2500
          })
        }
        await this.refreshBookings()
        const refreshed = (this.bookingRecords || []).find(
          (b) => b && String(b._id) === String(this.selectedBooking._id)
        )
        if (refreshed) {
          this.cacheDutyAssignUsers(refreshed.duty_assigned_to)
          this.selectedBooking = { ...this.selectedBooking, ...refreshed }
          this.syncDutyAssignForm()
        }
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: (error && error.message) || 'Failed to update duty assignees',
          color: 'danger',
          position: 'top-center',
          time: 3000
        })
        throw error
      } finally {
        this.dutyAssignSaving = false
      }
    },
    openWhatsApp(phoneNumber) {

      if (!phoneNumber) {
        this.$vs.notify({
          title: 'Error',
          text: 'No phone number available',
          color: 'warning',
          position: 'top-center',
          time: 2000
        })
        return
      }

      try {
        // Clean the phone number - remove all non-digit characters except +
        let cleanNumber = phoneNumber.replace(/[^\d+]/g, '')

        // If it doesn't start with +, add +91 for Indian numbers
        if (!cleanNumber.startsWith('+')) {
          // Remove leading zeros
          cleanNumber = cleanNumber.replace(/^0+/, '')
          // Add country code if not present
          if (!cleanNumber.startsWith('91')) {
            cleanNumber = `91${cleanNumber}`
          }
          cleanNumber = `+${cleanNumber}`
        }

        // Create WhatsApp URL
        const whatsappUrl = `https://wa.me/${cleanNumber}`

        // Open WhatsApp
        const newWindow = window.open(whatsappUrl, '_blank', 'noopener,noreferrer')

        if (newWindow) {
          this.$vs.notify({
            title: 'WhatsApp',
            text: 'Opening WhatsApp chat...',
            color: 'success',
            position: 'top-center',
            time: 2000
          })
        } else {
          throw new Error('Popup blocked')
        }
      } catch (error) {
        console.error('WhatsApp error:', error)
        this.$vs.notify({
          title: 'Error',
          text: 'Failed to open WhatsApp. Please check popup settings.',
          color: 'danger',
          position: 'top-center',
          time: 3000
        })
      }
    },
    openDetailPanel(booking) {
      if (!booking) return
      this.selectedBooking = booking
      this.syncDutyAssignForm()
      try {
        this.documents = this.buildDocumentsFromBooking(booking)
        this.originalDocuments = JSON.parse(JSON.stringify(this.documents || []))
        this.requestedDocuments = this.buildRequestedDocumentsFromBooking(booking)
      } catch (error) {
        console.error('Failed to prepare booking details', error)
        this.documents = []
        this.originalDocuments = []
        this.requestedDocuments = []
      }
      this.newDocuments = []
      this.documentsModified = false
      this.showDetailPanel = true
      this.isPanelMinimized = false
      this.lockBodyScroll()
      this.$nextTick(() => this.attachOverlaysToBody())
    },
    openPaymentRequestPanel() {
      if (!this.featureFlags.enablePaymentGateway) return
      this.isNewBookingFlow = false;
      // Initialize payment values from booking if available
      if (this.selectedBooking) {
        this.serviceCharge = this.selectedBooking.service_amount || this.selectedBooking.total_service_amount || 0
        this.platformFeeAmount = this.selectedBooking.platform_fee || 0;

        // Calculate percentage from existing values if possible
        if (this.serviceCharge > 0) {
          const p = ((this.platformFeeAmount / this.serviceCharge) * 100).toFixed(2)
          // Remove trailing .00
          this.platformFeePercentage = parseFloat(p)
        } else {
          // Try to fetch from nested object
          const s = this.selectedBooking.gurudwara_service
          const masterService = s && s.service
          this.platformFeePercentage = (masterService && masterService.collection_platform_fee) || 0
        }

        // If netReceiveAmount is not set, calculate from serviceCharge
        if (!this.netReceiveAmount && this.serviceCharge > 0) {
          this.netReceiveAmount = Number((this.serviceCharge - this.platformFeeAmount).toFixed(2))
        }
      }
      this.showPaymentRequestPanel = true
      this.showDetailPanel = false
      this.isPanelMinimized = false
      this.lockBodyScroll()
    },
    async sendPaymentRequest() {
      if (!this.featureFlags.enablePaymentGateway) return
      if (!this.isNewBookingFlow && (!this.canSendPaymentRequest || !this.selectedBooking)) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please ensure all documents are accepted and service charge is set',
          color: 'danger',
          position: 'top-center',
          time: 3000
        })
        return
      }

      const serviceCharge = Number(this.serviceCharge) || 0
      const platformFee = this.calculatedPlatformFee
      const netReceive = Number(this.netReceiveAmount) || 0

      if (serviceCharge <= 0) {
        this.$vs.notify({
          title: 'Error',
          text: 'Service charge must be greater than 0',
          color: 'danger',
          position: 'top-center',
          time: 3000
        })
        return
      }

      try {
        // Show loading
        this.$vs.loading({
          container: '.send-payment-btn',
          scale: 0.45
        })

        if (this.isNewBookingFlow) {
          // NEW BOOKING FLOW: Call proceedBooking with updated fees
          const gurudwaraId = this.gurudwaraId

          let startTime = '';
          let endTime = '';
          let bookingDateFormatted = null;

          if (!this.requiresToken) {
            const slotTimes = this.newBooking.selectedSlotKey ? this.newBooking.selectedSlotKey.split('-') : []
            startTime = slotTimes[0] || ''
            endTime = slotTimes[1] || ''
            if (this.newBooking.date) {
              bookingDateFormatted = moment(this.newBooking.date).format('YYYY-MM-DD')
            }
          } else {
            bookingDateFormatted = moment().format('YYYY-MM-DD');
          }

          const payload = {
            service_id: this.newBooking.serviceId,
            gurudwara_id: gurudwaraId,
            booking_date: bookingDateFormatted,
            start_time: startTime,
            end_time: endTime,
            total_amount: serviceCharge,
            platform_fee: platformFee,
            service_amount: serviceCharge - platformFee, // Backend expected service_amount
            user_id: this.newBooking.userId,
            requires_token: this.requiresToken
          }

          if (!startTime) delete payload.start_time;
          if (!endTime) delete payload.end_time;
          if (!bookingDateFormatted) delete payload.booking_date;

          if (this.newBooking.collectDocuments && this.newBookingDocuments.length > 0) {
            payload.collect_documents = this.newBookingDocuments.map((doc) => ({
              document_name: doc.document_name || 'New Document',
              is_required: doc.isRequired !== false,
              description: doc.uploadHint || ''
            }))
          } else {
            payload.collect_documents = []
          }

          const response = await this.$store.dispatch('service/proceedBooking', payload)

          // Call send-payment-request API if booking was created successfully
          if (response && response.data && response.data._id) {
            try {
              await this.sendPaymentRequestAction({
                bookingId: response.data._id,
                service_amount: serviceCharge,
                platform_fee: platformFee,
                net_receive_amount: netReceive,
                total_amount: serviceCharge
              })
            } catch (paymentError) {
              console.error('Failed to send payment request after booking creation:', paymentError)
              // We don't necessarily want to fail the whole process if creation succeeded but payment request failed
              this.$vs.notify({
                title: 'Partial Success',
                text: 'Booking created, but failed to send payment request automatically.',
                color: 'warning',
                position: 'top-center',
                time: 4000
              })
            }
          }

          this.$vs.loading.close('.send-payment-btn > .con-vs-loading')
          this.$vs.notify({
            title: 'Success',
            text: response.message || (this.requiresToken ? 'Payment Request Sent' : 'Booking created successfully'),
            color: 'success',
            position: 'top-center',
            time: 3000
          })
        } else {
          // EXISTING BOOKING FLOW: Send payment request
          const response = await this.sendPaymentRequestAction({
            bookingId: this.selectedBooking._id,
            service_amount: serviceCharge,
            platform_fee: platformFee,
            net_receive_amount: netReceive,
            total_amount: serviceCharge
          })

          this.$vs.loading.close('.send-payment-btn > .con-vs-loading')
          this.$vs.notify({
            title: 'Success',
            text: response.message || 'Payment request sent successfully',
            color: 'success',
            position: 'top-center',
            time: 4000
          })
        }

        // Close all panels and refresh bookings
        this.closeAllPanels()
        await this.refreshBookings()
      } catch (error) {
        // Close loading on error
        this.$vs.loading.close('.send-payment-btn > .con-vs-loading')
        this.$vs.loading.close('.send-payment-btn')

        const message = error && error.message ? error.message : 'Failed to send payment request'
        this.$vs.notify({
          title: 'Error',
          text: message,
          color: 'danger',
          position: 'top-center',
          time: 4000
        })
      } finally {
        // Ensure loading is closed and body scroll is unlocked
        this.$vs.loading.close('.send-payment-btn > .con-vs-loading')
        this.$vs.loading.close('.send-payment-btn')
        this.unlockBodyScroll()
      }
    },
    closePaymentRequestPanel() {
      this.showPaymentRequestPanel = false
      this.isPanelMinimized = false
      if (this.isNewBookingFlow) {
        this.showNewBookingModal = true
      } else {
        this.showDetailPanel = true
      }
      this.unlockBodyScroll()
    },
    onDetailOverlayClick() {
      if (this.showDocPreviewModal) {
        this.closeDocPreviewModal()
        return
      }
      this.closeDetailPanel()
    },
    closeDetailPanel() {
      // Warn user if there are unsaved changes
      if (this.documentsModified) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'warning',
          title: 'Unsaved Changes',
          text: 'You have unsaved changes. Are you sure you want to close?',
          acceptText: 'Close Anyway',
          cancelText: 'Cancel',
          accept: () => {
            this.closeAllPanels()
          }
        })
      } else {
        this.closeAllPanels()
      }
    },
    toggleStatusMenu() {
      this.showStatusMenu = !this.showStatusMenu
      if (this.showStatusMenu) {
        document.addEventListener('click', this.onOutsideStatusClick, true)
      } else {
        document.removeEventListener('click', this.onOutsideStatusClick, true)
      }
    },
    onOutsideStatusClick(e) {
      const root = this.$refs && this.$refs.statusActionRef
      if (root && !root.contains(e.target)) {
        this.showStatusMenu = false
        document.removeEventListener('click', this.onOutsideStatusClick, true)
      }
    },
    async applyStatusChange(status) {
      if (!this.selectedBooking) return

      if (status === 'Confirmed' && !this.canApprovePendingBooking) {
        this.showStatusMenu = false
        this.$vs.notify({
          title: 'Duty required',
          text: 'Assign at least one Sangat user to duty before approving this booking.',
          color: 'warning',
          position: 'top-center',
          time: 3500
        })
        return
      }

      // If status is Rejected or Cancelled, show reason dialog
      if (status === 'Refunded' && !this.isPaymentPaid(this.selectedBooking)) {
        this.showStatusMenu = false
        this.$vs.notify({
          title: 'Payment not received',
          text: 'Mark as Refunded is available only after payment is received.',
          color: 'warning',
          position: 'top-center'
        })
        return
      }

      if (status === 'Rejected' || status === 'Cancelled') {
        this.pendingStatusChange = status
        this.rejectionReason = ''
        this.showRejectionDialog = true
        this.showStatusMenu = false
        document.removeEventListener('click', this.onOutsideStatusClick, true)
        return
      }

      // For other statuses, proceed directly
      await this.executeStatusChange(status)
    },
    async executeStatusChange(status, rejectionReason = null) {
      if (!this.selectedBooking) return

      if (status === 'Confirmed' && !this.canApprovePendingBooking) {
        this.showStatusMenu = false
        this.$vs.notify({
          title: 'Duty required',
          text: 'Assign at least one Sangat user to duty before approving this booking.',
          color: 'warning',
          position: 'top-center',
          time: 3500
        })
        return
      }

      const prev = this.selectedBooking.booking_status
      const prevToken = this.selectedBooking.token_status
      const nextPatch = { booking_status: status }
      if (status === 'Completed') nextPatch.token_status = 'Completed'
      this.patchBookingRecord({ ...this.selectedBooking, ...nextPatch })
      this.showStatusMenu = false
      document.removeEventListener('click', this.onOutsideStatusClick, true)
      try {
        if (status === 'Confirmed') {
          await this.saveDutyAssign({ silent: true, notify: true })
          this.clearDutyAssignDraft(this.selectedBooking._id)
        }
        const payload = { id: this.selectedBooking._id, booking_status: status }
        if (rejectionReason) payload.rejection_reason = rejectionReason
        const response = await this.updateBookingStatus(payload)

        if (response && response.data) {
          this.patchBookingRecord({ ...this.selectedBooking, ...response.data, ...nextPatch })
          this.$vs.notify({
            title: 'Status Updated',
            text: `Booking marked as ${status}${rejectionReason ? ' with reason' : ''}`,
            color: 'success',
            position: 'top-center',
            time: 1800
          })
          this.refreshBookings()
        }
      } catch (e) {
        this.patchBookingRecord({
          ...this.selectedBooking,
          booking_status: prev,
          token_status: prevToken
        })
        const message = (e && e.message) || 'Failed to update status'
        this.$vs.notify({ title: 'Error', text: message, color: 'danger', position: 'top-center', time: 2500 })
        this.refreshBookings()
      }
    },
    closeAllPanels() {
      this.showDocPreviewModal = false
      this.previewImageUrls = []
      this.showDetailPanel = false
      this.showPaymentRequestPanel = false
      this.showNewBookingModal = false
      this.isPanelMinimized = false
      this.isNewBookingMinimized = false
      this.selectedBooking = null
      this.showStatusMenu = false
      this.newDocuments = []
      this.requestedDocuments = []
      this.documentsModified = false
      this.originalDocuments = []
      this.resetNewBooking()
      this.unlockBodyScroll()
    },
    confirmRejection() {
      if (!this.rejectionReason || this.rejectionReason.trim() === '') {
        this.$vs.notify({
          title: 'Required',
          text: 'Please provide a reason for rejection/cancellation',
          color: 'warning',
          position: 'top-center',
          time: 2500
        })
        return
      }
      this.showRejectionDialog = false
      const status = this.pendingStatusChange
      this.pendingStatusChange = null
      this.executeStatusChange(status, this.rejectionReason.trim())
      this.rejectionReason = ''
    },
    cancelRejection() {
      this.showRejectionDialog = false
      this.pendingStatusChange = null
      this.rejectionReason = ''
    },
    confirmMarkAsDone(item) {
      if (!item) return
      this.selectedBooking = item
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirm Completion',
        text: `Are you sure you want to mark this booking (Token: ${item.token_number}) as Completed?`,
        acceptText: 'Yes, Mark as Done',
        cancelText: 'Cancel',
        accept: () => {
          this.executeStatusChange('Completed')
        }
      })
    },
    confirmMarkPrasadGiven(item) {
      if (!item) return
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Given Prasad',
        text: `Mark prasad as given for token ${item.token_number || ''}?`,
        acceptText: 'Yes, Given Prasad',
        cancelText: 'Cancel',
        accept: () => {
          this.updatePrasadCollectionStatus(item, { prasad_status: 'Given' }, 'Prasad marked as given')
        }
      })
    },
    confirmApprovePayment(item) {
      if (!item) return
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Payment Received',
        text: `Mark payment as received for token ${item.token_number || ''}?`,
        acceptText: 'Yes, Payment Received',
        cancelText: 'Cancel',
        accept: () => {
          this.updatePrasadCollectionStatus(item, { payment_status: 'Paid' }, 'Payment received')
        }
      })
    },
    applyBookingStatusOverrides() {
      const overrides = this.bookingStatusOverrides || {}
      const list = Array.isArray(this.bookingRecords) ? this.bookingRecords : []
      if (!list.length || !Object.keys(overrides).length) return
      const next = list.map((booking) => {
        if (!booking || !booking._id) return booking
        const override = this.cleanStatusPatch(overrides[String(booking._id)])
        return Object.keys(override).length ? { ...booking, ...override } : booking
      })
      this.$store.commit('service/SET_STATE', { action: 'bookingRecords', data: next })
    },
    cleanStatusPatch(patch) {
      const clean = {}
      if (!patch) return clean
      Object.keys(patch).forEach((key) => {
        if (patch[key] !== undefined && patch[key] !== null && patch[key] !== '') {
          clean[key] = patch[key]
        }
      })
      return clean
    },
    setBookingStatusOverride(item, patch) {
      if (!item || !item._id) return
      const id = String(item._id)
      const cleanPatch = this.cleanStatusPatch(patch)
      if (!Object.keys(cleanPatch).length) return
      const current = this.cleanStatusPatch(this.bookingStatusOverrides[id] || {})
      this.$set(this.bookingStatusOverrides, id, { ...current, ...cleanPatch })
      const existing = (this.bookingRecords || []).find((booking) => booking && String(booking._id) === id) || item
      this.patchBookingRecord({
        _id: item._id,
        ...this.cleanStatusPatch({
          prasad_status: existing.prasad_status,
          payment_status: existing.payment_status
        }),
        ...current,
        ...cleanPatch
      })
    },
    patchBookingRecord(updated) {
      if (!updated || !updated._id) return
      const updatedId = String(updated._id)
      const cleanUpdated = this.cleanStatusPatch(updated)
      const list = Array.isArray(this.bookingRecords) ? this.bookingRecords : []
      const next = list.map((booking) => {
        if (booking && String(booking._id) === updatedId) {
          return { ...booking, ...cleanUpdated }
        }
        return booking
      })
      this.$store.commit('service/SET_STATE', { action: 'bookingRecords', data: next })
      if (this.selectedBooking && String(this.selectedBooking._id) === updatedId) {
        this.selectedBooking = { ...this.selectedBooking, ...cleanUpdated }
      }
    },
    async updatePrasadCollectionStatus(item, payload, successText) {
      if (!item) return
      const id = String(item._id)
      const previousOverride = { ...(this.bookingStatusOverrides[id] || {}) }
      const cleanPayload = this.cleanStatusPatch(payload)
      this.setBookingStatusOverride(item, cleanPayload)
      try {
        const body = { ...cleanPayload }
        if (cleanPayload.payment_status === 'Paid') {
          body.mark_payment_received = true
        }
        await this.$http.put(`admin/gurudwara-service-booking/status/${item._id}`, body)
        this.$vs.notify({
          title: 'Updated',
          text: successText,
          color: 'success',
          position: 'top-center',
          time: 1800
        })
      } catch (e) {
        if (Object.keys(previousOverride).length) {
          this.$set(this.bookingStatusOverrides, id, previousOverride)
        } else {
          this.$delete(this.bookingStatusOverrides, id)
        }
        this.patchBookingRecord({ _id: item._id, ...previousOverride })
        const message = (e && e.response && e.response.data && e.response.data.message) || (e && e.message) || 'Failed to update booking'
        this.$vs.notify({ title: 'Error', text: message, color: 'danger', position: 'top-center', time: 2500 })
      }
    },
    confirmDocRejection() {
      if (!this.docRejectionReason || this.docRejectionReason.trim() === '') {
        this.$vs.notify({
          title: 'Required',
          text: 'Please provide a reason for document rejection',
          color: 'warning',
          position: 'top-center',
          time: 2500
        })
        return
      }
      this.showDocRejectionDialog = false
      const key = this.pendingDocRejection
      const reason = this.docRejectionReason.trim()
      this.pendingDocRejection = null
      this.docRejectionReason = ''

      // Update document status with custom rejection reason
      this.documents = this.documents.map((d) => {
        if (d.key === key) {
          return { ...d, status: 'rejected', rejectionReason: reason }
        }
        return d
      })
      this.checkDocumentsModified()

      this.$vs.notify({
        title: 'Document Rejected',
        text: 'Document has been rejected with reason',
        color: 'danger',
        position: 'top-center',
        time: 2000
      })
    },
    cancelDocRejection() {
      this.showDocRejectionDialog = false
      this.pendingDocRejection = null
      this.docRejectionReason = ''
    },
    togglePanelMinimize() {
      if (this.showDocPreviewModal) {
        this.closeDocPreviewModal()
      }
      this.isPanelMinimized = !this.isPanelMinimized

      // Lock/unlock scroll based on panel state
      if (this.isPanelMinimized) {
        this.unlockBodyScroll()
      } else {
        this.lockBodyScroll()
      }
      this.$nextTick(() => this.attachOverlaysToBody())

      // this.$vs.notify({
      //   title: 'Panel',
      //   text: this.isPanelMinimized ? 'Panel minimized' : 'Panel maximized',
      //   color: 'primary',
      //   position: 'top-center',
      //   time: 1500
      // })
    },
    togglePaymentPanelMinimize() {
      this.isPanelMinimized = !this.isPanelMinimized

      // Lock/unlock scroll based on panel state
      if (this.isPanelMinimized) {
        this.unlockBodyScroll()
      } else {
        this.lockBodyScroll()
        this.showDetailPanel = true
      }

      // this.$vs.notify({
      //   title: 'Panel',
      //   text: this.isPanelMinimized ? 'Panel minimized' : 'Panel maximized',
      //   color: 'primary',
      //   position: 'top-center',
      //   time: 1500
      // })
    },
    async refreshBookingDetails() {
      if (!this.selectedBooking || !this.selectedBooking._id) {
        this.$vs.notify({
          title: 'Warning',
          text: 'No booking selected to refresh',
          color: 'warning',
          position: 'top-center',
          time: 2000
        })
        return
      }

      try {
        // Show loading indicator on the detail panel
        this.$vs.loading({
          container: '.detail-panel',
          scale: 0.6
        })

        // Store the booking ID before refreshing
        const bookingId = this.selectedBooking._id

        // Refresh the listing in the background
        await this.refreshBookings()

        // Wait a bit for the store to update with the new data
        await this.$nextTick()

        // Find the updated booking from the refreshed listing
        const updatedBooking = this.bookingRecords.find(b => b._id === bookingId)

        if (updatedBooking) {
          // Update selectedBooking with fresh data
          this.selectedBooking = updatedBooking
          this.documents = this.buildDocumentsFromBooking(updatedBooking)
          this.originalDocuments = JSON.parse(JSON.stringify(this.documents))
          this.requestedDocuments = this.buildRequestedDocumentsFromBooking(updatedBooking)
          this.documentsModified = false
          this.newDocuments = []

          // Show success toast
          this.$vs.notify({
            title: 'Success',
            text: 'Booking details refreshed successfully',
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-check',
            position: 'top-center',
            time: 2000
          })
        } else {
          // Booking not found in refreshed list
          this.$vs.notify({
            title: 'Warning',
            text: 'Booking not found in refreshed list',
            color: 'warning',
            position: 'top-center',
            time: 2000
          })
        }
      } catch (error) {
        console.error('Refresh booking details error:', error)
        this.$vs.notify({
          title: 'Error',
          text: 'Failed to refresh booking details',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 3000
        })
      } finally {
        // Close loading indicator
        this.$vs.loading.close('.detail-panel > .con-vs-loading')
      }
    },
    buildDocumentsFromBooking(booking) {
      const uploaded = booking && Array.isArray(booking.uploaded_documents) ? booking.uploaded_documents : []
      if (!uploaded.length) return []
      return uploaded.map((doc, idx) => {
        const key = (
          doc.key ||
          (doc._id && doc._id.toString && doc._id.toString()) ||
          (doc.id && String(doc.id)) ||
          doc.document_key ||
          doc.document_type ||
          doc.type ||
          doc.name ||
          `doc_${idx}`
        ).toString()
        const labelSrc = doc.label || doc.display_name || doc.document_label || doc.document_type || doc.type || doc.name || key
        const documentName = doc.document_name || labelSrc
        let fileUrls = this.normalizeFileList(doc.file_urls)
        if (!fileUrls.length) {
          fileUrls = this.normalizeFileList([doc.url, doc.file_url, doc.document_url, doc.path])
        }
        const status = doc.status || 'pending'
        return {
          key,
          _id: doc._id || doc.id || null, // Store _id for backend matching
          label: labelSrc,
          document_name: documentName,
          file_urls: fileUrls,
          status,
          rejectionReason: doc.rejection_reason || doc.rejectionReason || null
        }
      })
    },
    buildRequestedDocumentsFromBooking(booking) {
      const requested = booking && Array.isArray(booking.requested_documents) ? booking.requested_documents : []
      if (!requested.length) return []
      return requested.map((doc, idx) => ({
        key: `requested_${idx}`,
        _id: doc._id || doc.id || null, // Store original ID for updates/deletes
        document_name: doc.document_name || 'New Document',
        isRequired: doc.is_required !== false,
        uploadHint: doc.description || '',
        requested_at: doc.requested_at,
        isSaved: true, // Mark as saved to distinguish from temporary newDocuments
        isEditing: false,
        originalData: { ...doc } // Store original data for change tracking
      }))
    },
    approveDocument(documentType) {
      // Handle document approval
      this.$vs.notify({
        title: 'Document Approved',
        text: `${documentType} has been approved`,
        color: 'success',
        position: 'top-center',
        time: 3000
      })
    },
    rejectDocument(documentType) {
      // Handle document rejection
      this.$vs.notify({
        title: 'Document Rejected',
        text: `${documentType} has been rejected`,
        color: 'danger',
        position: 'top-center',
        time: 3000
      })
    },
    setDocumentStatus(key, status) {
      // If status is rejected, show reason dialog
      if (status === 'rejected') {
        this.pendingDocRejection = key
        this.docRejectionReason = ''
        this.showDocRejectionDialog = true
        return
      }

      // For other statuses (accepted, pending), proceed directly
      this.documents = this.documents.map((d) => {
        if (d.key === key) {
          const updated = { ...d, status }
          if (status === 'pending') {
            updated.rejectionReason = null
          }
          return updated
        }
        return d
      })
      this.checkDocumentsModified()
      let text = ''
      let color = 'primary'
      if (status === 'accepted') {
        text = 'Document Accepted'
        color = 'success'
      } else {
        text = 'Status changed'
      }
      this.$vs.notify({ title: 'Documents', text, color, position: 'top-center', time: 2000 })
    },
    normalizeFileList(list) {
      const queue = []
      if (Array.isArray(list)) {
        queue.push(...list)
      } else if (list) {
        queue.push(list)
      }

      const urls = []
      while (queue.length) {
        const item = queue.shift()
        if (!item) continue
        if (Array.isArray(item)) {
          queue.push(...item)
          continue
        }
        if (typeof item === 'string') {
          urls.push(item)
        } else if (typeof item === 'object') {
          const possible =
            item.url ||
            item.file_url ||
            item.document_url ||
            item.path ||
            item.source ||
            item.src
          if (possible) urls.push(possible)
        }
      }
      return urls
    },
    getDocFileCount(doc) {
      if (!doc) return 0
      return this.normalizeFileList(doc.file_urls).length
    },
    hasDocFiles(doc) {
      return this.getDocFileCount(doc) > 0
    },
    primaryDocImage(doc) {
      if (!doc) return null
      const urls = this.normalizeFileList(doc.file_urls)
      return urls.length ? urls[0] : null
    },
    triggerDocUpload(key) {
      const refKey = `docInput-${key}`
      const input = this.$refs[refKey]
      if (input && input[0]) {
        input[0].click()
      } else if (input) {
        input.click()
      }
    },
    onDocFileChange(key, event) {
      const input = event && event.target
      const files = input && input.files ? Array.from(input.files) : []
      if (!files.length) return

      const readers = files.map(
        (file) => new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onload = (e) => resolve(e && e.target ? e.target.result : null)
          reader.onerror = () => reject(new Error('Failed to read file'))
          reader.readAsDataURL(file)
        })
      )

      Promise.all(readers)
        .then((results) => {
          const fileUrls = results.filter(Boolean)
          if (!fileUrls.length) return
          this.documents = this.documents.map((d) => {
            if (d.key === key) {
              return { ...d, file_urls: fileUrls, status: 'pending' }
            }
            return d
          })
          this.$vs.notify({ title: 'Upload', text: 'Document uploaded (preview only)', color: 'success', position: 'top-center', time: 2000 })
        })
        .catch(() => {
          this.$vs.notify({ title: 'Upload', text: 'Failed to process selected files', color: 'danger', position: 'top-center', time: 2000 })
        })
        .finally(() => {
          if (input) input.value = ''
        })
    },
    openDocPreview(files) {
      const urls = this.normalizeFileList(files)
      if (!urls.length) return

      // Set preview URLs and show modal
      this.previewImageUrls = urls
      this.showDocPreviewModal = true
      this.lockBodyScroll()
    },
    closeDocPreviewModal() {
      this.showDocPreviewModal = false
      this.previewImageUrls = []
      this.unlockBodyScroll()
    },
    // Test method to verify clicks are working
    testIconClick(iconName) {
      this.$vs.notify({
        title: 'Icon Test',
        text: `${iconName} icon is working!`,
        color: 'success',
        position: 'top-center',
        time: 2000
      })
    },
    // Scroll lock methods
    lockBodyScroll() {
      // Store the current scroll position
      this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop

      // Apply styles to prevent scrolling
      document.body.style.position = 'fixed'
      document.body.style.top = `-${this.scrollPosition}px`
      document.body.style.width = '100%'
      document.body.style.overflow = 'hidden'

    },
    unlockBodyScroll() {
      // Remove the fixed positioning
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.width = ''
      document.body.style.overflow = ''

      // Restore the scroll position
      if (this.scrollPosition !== undefined) {
        window.scrollTo(0, this.scrollPosition)
        this.scrollPosition = undefined
      }

    },
    // Handle escape key to close panel
    handleEscapeKey(event) {
      if (event.key !== 'Escape') return
      if (this.showDocPreviewModal) {
        this.closeDocPreviewModal()
        return
      }
      if (this.showDetailPanel) {
        this.closeDetailPanel()
        return
      }
      if (this.showNewBookingModal) {
        this.closeNewBookingModal()
        return
      }
      if (this.showStatusMenu) {
        this.showStatusMenu = false
        document.removeEventListener('click', this.onOutsideStatusClick, true)
      }
    },
    // New Document Management Methods
    addNewDocument() {
      this.newDocuments.push({
        document_name: 'Aadhaar Card',
        isRequired: true,
        isEditing: false,
        uploadHint: 'Upload both front and back side together.'
      })
      this.checkDocumentsModified()
    },
    editNewDocument(idx) {
      if (this.newDocuments[idx]) {
        // Close any other editing documents first
        this.newDocuments.forEach((doc, i) => {
          if (i !== idx && doc.isEditing) {
            doc.isEditing = false
          }
        })
        this.newDocuments[idx].isEditing = true
        this.$nextTick(() => {
          const refKey = `newDocInput-${idx}`
          const input = this.$refs[refKey]
          if (input && input[0]) {
            input[0].focus()
          } else if (input) {
            input.focus()
          }
        })
        this.checkDocumentsModified()
      }
    },
    handleNewDocCardClick(idx, event) {
      // Don't close if clicking on Edit/Delete buttons
      if (event.target.closest('.doc-action-btn')) {
        return
      }
      // Don't close if clicking inside the edit form (input, radio buttons, labels)
      if (event.target.closest('.new-doc-edit-form')) {
        return
      }
      // Close edit mode if clicking elsewhere on the card
      if (this.newDocuments[idx] && this.newDocuments[idx].isEditing) {
        this.finishEditingNewDocument(idx)
      }
    },
    finishEditingNewDocument(idx) {
      if (this.newDocuments[idx]) {
        this.newDocuments[idx].isEditing = false
        this.checkDocumentsModified()
      }
    },
    deleteNewDocument(idx) {
      this.newDocuments.splice(idx, 1)
      this.checkDocumentsModified()
    },
    // New Booking Document Management Methods
    addNewBookingDocument() {
      this.newBookingDocuments.push({
        document_name: 'Aadhaar Card',
        isRequired: true,
        isEditing: false,
        uploadHint: 'Upload both front and back side together.'
      })
    },
    editNewBookingDocument(idx) {
      if (this.newBookingDocuments[idx]) {
        // Close any other editing documents first
        this.newBookingDocuments.forEach((doc, i) => {
          if (i !== idx && doc.isEditing) {
            doc.isEditing = false
          }
        })
        this.newBookingDocuments[idx].isEditing = true
        this.$nextTick(() => {
          const refKey = `newBookingDocInput-${idx}`
          const input = this.$refs[refKey]
          if (input && input[0]) {
            input[0].focus()
          } else if (input) {
            input.focus()
          }
        })
      }
    },
    handleNewBookingDocCardClick(idx, event) {
      // Don't close if clicking on Edit/Delete buttons
      if (event.target.closest('.doc-action-btn')) {
        return
      }
      // Don't close if clicking inside the edit form (input, radio buttons, labels)
      if (event.target.closest('.new-doc-edit-form')) {
        return
      }
      // Close edit mode if clicking elsewhere on the card
      if (this.newBookingDocuments[idx] && this.newBookingDocuments[idx].isEditing) {
        this.finishEditingNewBookingDocument(idx)
      }
    },
    finishEditingNewBookingDocument(idx) {
      if (this.newBookingDocuments[idx]) {
        this.newBookingDocuments[idx].isEditing = false
      }
    },
    getNewBookingUserName() {
      if (!this.newBooking.userId) return ''
      const users = (this.userRecords || (this.$store.state.user && this.$store.state.user.records) || [])
      const user = users.find(u => String(u._id) === String(this.newBooking.userId))
      return this.formatUserDisplayName(user) || 'Unknown User'
    },
    getNewBookingServiceName() {
      if (!this.newBooking.serviceId) return ''
      const service = (this.records || []).find(s => s._id === this.newBooking.serviceId)
      return (service.service.service_name || service.service_name) || 'Unknown Service'
    },
    getNewBookingSlotTime() {
      if (this.requiresToken) return 'Flexible'
      const slotTimes = this.newBooking.selectedSlotKey ? this.newBooking.selectedSlotKey.split('-') : []
      return this.formatTime(slotTimes[0]) || '—'
    },
    // Requested Document Management Methods
    editRequestedDocument(idx) {
      if (this.requestedDocuments[idx]) {
        // Close any other editing documents first
        this.requestedDocuments.forEach((doc, i) => {
          if (i !== idx && doc.isEditing) {
            doc.isEditing = false
          }
        })
        this.newDocuments.forEach((doc, i) => {
          if (doc.isEditing) {
            doc.isEditing = false
          }
        })
        this.requestedDocuments[idx].isEditing = true
        this.$nextTick(() => {
          const refKey = `requestedDocInput-${idx}`
          const input = this.$refs[refKey]
          if (input && input[0]) {
            input[0].focus()
          } else if (input) {
            input.focus()
          }
        })
        this.checkDocumentsModified()
      }
    },
    finishEditingRequestedDocument(idx) {
      if (this.requestedDocuments[idx]) {
        this.requestedDocuments[idx].isEditing = false
        this.checkDocumentsModified()
      }
    },
    handleRequestedDocCardClick(idx, event) {
      // Don't close if clicking on Edit/Delete buttons
      if (event.target.closest('.doc-action-btn')) {
        return
      }
      // Don't close if clicking inside the edit form (input, radio buttons, labels)
      if (event.target.closest('.new-doc-edit-form')) {
        return
      }
      // Close edit mode if clicking elsewhere on the card
      if (this.requestedDocuments[idx] && this.requestedDocuments[idx].isEditing) {
        this.finishEditingRequestedDocument(idx)
      }
    },
    deleteRequestedDocument(idx) {
      if (this.requestedDocuments[idx]) {
        this.requestedDocuments.splice(idx, 1)
        this.checkDocumentsModified()
      }
    },
    deleteNewBookingDocument(idx) {
      this.newBookingDocuments.splice(idx, 1)
    },
    // Check if documents have been modified
    checkDocumentsModified() {
      // Check if document statuses have changed
      const statusChanged = this.documents.some((doc, idx) => {
        const original = this.originalDocuments[idx]
        return !original || original.status !== doc.status || original.rejectionReason !== doc.rejectionReason
      })

      // Check if new documents have been added
      const newDocsAdded = this.newDocuments.length > 0

      // Check if documents array length changed
      const lengthChanged = this.documents.length !== this.originalDocuments.length

      // Check if requested documents have been modified
      const requestedDocsModified = this.requestedDocuments.some((doc) => {
        if (!doc.originalData) return false
        return (
          doc.document_name !== doc.originalData.document_name ||
          doc.isRequired !== (doc.originalData.is_required !== false) ||
          doc.uploadHint !== (doc.originalData.description || '')
        )
      })

      // Check if requested documents have been deleted
      const originalRequestedCount = this.selectedBooking && Array.isArray(this.selectedBooking.requested_documents)
        ? this.selectedBooking.requested_documents.length
        : 0
      const requestedDocsDeleted = this.requestedDocuments.length < originalRequestedCount

      this.documentsModified = statusChanged || newDocsAdded || lengthChanged || requestedDocsModified || requestedDocsDeleted
    },
    // Save booking changes (document statuses and new documents)
    async saveBookingChanges() {
      if (!this.selectedBooking || !this.documentsModified) return

      try {
        // Build document status updates
        // Use key first, fallback to _id for backend matching
        // Only include documents that have a valid key or _id
        const document_statuses = this.documents
          .filter((doc) => doc.key || doc._id || doc.document_name) // Only include documents with valid identifier
          .map((doc) => ({
            document_key: doc.key || doc._id.toString() || doc.document_name,
            status: doc.status,
            rejection_reason: doc.status === 'rejected' ? (doc.rejectionReason || 'Incorrect document uploaded.') : null
          }))

        // Build new document requests
        const new_document_requests = this.newDocuments.map((doc) => ({
          document_name: doc.document_name || 'New Document',
          is_required: doc.isRequired !== false,
          description: doc.uploadHint || ''
        }))

        // Build updated requested documents (edited ones)
        const updated_requested_documents = this.requestedDocuments
          .filter((doc) => doc.isSaved && doc.originalData) // Only saved documents
          .map((doc) => ({
            _id: doc._id,
            document_name: doc.document_name || 'New Document',
            is_required: doc.isRequired !== false,
            description: doc.uploadHint || ''
          }))

        // Build deleted requested document IDs
        const originalRequestedIds = (this.selectedBooking.requested_documents || [])
          .map((doc) => doc._id || doc.id)
          .filter(Boolean)
        const currentRequestedIds = this.requestedDocuments
          .filter((doc) => doc.isSaved && doc._id)
          .map((doc) => doc._id)
          .filter(Boolean)
        const deleted_requested_document_ids = originalRequestedIds.filter(
          (id) => !currentRequestedIds.includes(id)
        )

        const payload = {
          document_statuses,
          new_document_requests: new_document_requests.length > 0 ? new_document_requests : undefined,
          updated_requested_documents: updated_requested_documents.length > 0 ? updated_requested_documents : undefined,
          deleted_requested_document_ids: deleted_requested_document_ids.length > 0 ? deleted_requested_document_ids : undefined
        }

        // Remove undefined fields
        if (!payload.new_document_requests) {
          delete payload.new_document_requests
        }
        if (!payload.updated_requested_documents) {
          delete payload.updated_requested_documents
        }
        if (!payload.deleted_requested_document_ids) {
          delete payload.deleted_requested_document_ids
        }

        // Call update API
        const response = await this.updateBooking({
          id: this.selectedBooking._id,
          data: payload
        })

        // Check if response is successful (status 200)
        if (response && response.data) {
          // Update selectedBooking with the response data
          this.selectedBooking = response.data

          // Rebuild documents from the updated booking
          this.documents = this.buildDocumentsFromBooking(response.data)
          this.originalDocuments = JSON.parse(JSON.stringify(this.documents))
          this.requestedDocuments = this.buildRequestedDocumentsFromBooking(response.data)

          // Reset modification tracking
          this.documentsModified = false
          this.newDocuments = []

          // Refresh booking list to update the list view
          await this.refreshBookings()

          // Update the booking in the list if it exists
          if (Array.isArray(this.bookingRecords)) {
            const idx = this.bookingRecords.findIndex(b => b._id === this.selectedBooking._id)
            if (idx > -1) {
              this.$set(this.bookingRecords, idx, response.data)
            }
          }

          // Show success notification
          this.$vs.notify({
            title: 'Success',
            text: response.message || 'Booking changes saved successfully',
            color: 'success',
            position: 'top-center',
            time: 3000
          })

          // Close the detail panel after successful save
          this.closeAllPanels()
        }
      } catch (error) {
        const message = error && error.message ? error.message : 'Failed to save booking changes'
        this.$vs.notify({
          title: 'Error',
          text: message,
          color: 'danger',
          position: 'top-center',
          time: 4000
        })
      }
    },

  }
}
</script>

<style scoped>
.slot-card {
  background: #fff;
  border: 1px solid #e5e7eb;
}

.slots-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 12px;
}

.booking-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.booking-toolbar-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.add-booking-btn {
  padding: 14px 18px !important;
}

.booking-status-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px 16px;
}

.status-tabs-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 20px;
}

.search-input-container {
  flex: 1 1 220px;
  min-width: 180px;
  max-width: 320px;
}

.prasad-filter-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 14px;
}

.slots-scroll-container {
  max-height: 320px;
  overflow-y: auto;
  padding-right: 12px;
}

.slot-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  border: 1px solid black;
  border-radius: 10px;
  background: #fff;
  color: #021C02;
  transition: all 0.2s ease;
  cursor: pointer;
}

.slot-btn:hover:not(.slot-disabled):not(.slot-limit-reached) {
  border-color: rgba(var(--vs-primary), 1);
}

.slot-selected {
  background: rgba(var(--vs-primary), 1);
  color: #fff;
  border-color: rgba(var(--vs-primary), 1);
}

.slot-disabled {
  background: #f3f4f6;
  border: none;
  color: #9ca3af;
  cursor: not-allowed;
}

.slot-limit-reached {
  background: #FFCECE;
  border: none;
  color: #400404;
  cursor: not-allowed;
}

.slot-hidden {
  background: #F0EFEE;
  border: none;
  color: #666666;
  cursor: pointer;
}

.slot-hidden:hover {
  background: #e5e7eb;
  border-color: #9ca3af;
}

.tab-btn {
  font-weight: 600;
  background: transparent;
  border: none;
  cursor: pointer;
  padding-bottom: 11px;
  font-size: 18px;
  color: black;
}

.tab-btn.active {
  border-bottom: 5px solid black;
}

.view_details {
  padding: 0 16px;
}

/* Slot Master Wrapper */
.slot-master-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.slot-master-wrapper.is-dialog-only {
  width: 0;
  height: 0;
  overflow: visible;
}

.slot-master-wrapper.is-dialog-only .slot-master-container {
  display: none;
}

.slot-master-dialog-only {
  position: static;
}

/* Slot Master Container - Creates inner scrolling like service form */
.slot-master-container {
  position: relative;
  width: 100%;
  max-height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Sticky Top Actions */
.sticky-top-actions-slot {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 0;
  width: 100%;
  flex-shrink: 0;
}

/* Scrollable Content */
.slot-master-content-scrollable {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Booking Card Container - Fixed height with inner scroll */
.booking-card-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: calc(100vh - 200px);
  overflow: hidden;
}

/* Sticky Header Section */
.booking-sticky-header {
  position: sticky;
  top: 0;
  flex-shrink: 0;
  background: #fff;
  z-index: 10;
  padding-bottom: 16px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 16px;
}

/* Sticky Status Tabs */
.sticky-status-tabs {
  padding-top: 16px;
  padding-bottom: 16px;
  margin-top: 16px;
  border-bottom: 1px solid #e5e7eb;
}

/* Scrollable Booking List */
.booking-list-scrollable {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 8px;
}

/* Custom Scrollbar */
.booking-list-scrollable::-webkit-scrollbar {
  width: 8px;
}

.booking-list-scrollable::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.booking-list-scrollable::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.booking-list-scrollable::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.text-danger {
  color: #991b1b;
}

/* Time Slot Header */
.time-slot-header {
  padding-bottom: 16px;
  border-bottom: 1px solid #e5e7eb;
}

.visibility-toggle-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 5px;
  background: #F0EFEE;
  color: #1E1E1E;
  border: none;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.visibility-toggle-btn:hover {
  background: #e5e7eb;
  color: #374151;
}

.visibility-toggle-btn.visible {
  background: #f3f4f6;
  color: #6b7280;
}

.visibility-toggle-btn svg {
  width: 24px;
  height: 24px;
}

/* Booking Item Container */
.booking-item-container {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
}

.booking-checkbox {
  margin-top: 4px;
}

/* Booking Card */
.booking-card {
  flex: 1;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
}

.booking-type-tag {
  background: #f3e8ff;
  color: #2c0146;
}

.new-booking-tag {
  background: #dcfce7;
  color: #166534;
}

.booking-card.is-new-booking {
  border: 2px solid #22c55e;
  animation: new-booking-pulse 1.1s ease-in-out 5;
}

@keyframes new-booking-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.5);
    border-color: #22c55e;
  }
  50% {
    box-shadow: 0 0 0 8px rgba(34, 197, 94, 0.12);
    border-color: #16a34a;
  }
  100% {
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);
    border-color: #22c55e;
  }
}

/* Booking Header */
.booking-header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.booking-tags {
  display: flex;
  align-items: center;
  gap: 20px 10px;
  flex-wrap: wrap;
}

.view-details-btn {
  display: flex;
  align-items: center;
  gap: 4px;
}

/* Tags and Chips */
.slot-chip {
  background: #111827;
  color: #fff;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 17px;
}

.tag {
  background: #f3f4f6;
  color: #374151;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 17px;
}

.tag.success {
  background: #9CFF9C;
  color: #2C0146;
}

.tag.warning {
  background: #F7E9FF;
  color: #2C0146;
}

.tag.danger {
  background: #991b1b;
  color: #fff;
}

/* User Name */
.user-name {
  font-size: 20px;
  font-weight: 700;
  color: black;
}

/* Booking Info Grid */
.booking-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px 20px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 9px;
}

.info-label {
  font-size: 15px;
  font-weight: 700;
  color: black;
  min-width: 120px;
}

.info-value {
  font-size: 16px;
  color: black;
}

.info-value-with-icon {
  display: flex;
  align-items: center;
  gap: 10px;
}

.info-value-with-icons {
  display: flex;
  align-items: center;
  gap: 10px;
}

.info-value-with-icon span,
.info-value-with-icons span {
  font-size: 16px;
  color: black;
}

/* Icons */
.copy-icon {
  color: black;
  cursor: pointer;
  transition: color 0.2s ease;
}


.whatsapp-icon {
  color: black;
  cursor: pointer;
  transition: color 0.2s ease;
}


/* Detailed Panel Styles */
.detail-panel-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 52000;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 20px;
}

.detail-panel-shell {
  position: relative;
  width: min(550px, calc(100vw - 40px));
  max-height: calc(100vh - 40px);
  margin-top: 60px;
  z-index: 1;
  overflow: hidden;
  border-radius: 20px;
}

.detail-panel {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  width: 100%;
  max-height: calc(100vh - 40px);
  overflow-y: auto;
  transition: all 0.3s ease;
  border: 1px solid #000000;
  position: relative;
  z-index: 1;
}

/* Minimized Panel Styles */
.minimized-panel {
  position: fixed;
  bottom: -50px;
  right: 20px;
  z-index: 52001;
  width: 500px;
  transition: all 0.3s ease;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.2), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
}

.minimized-panel-content {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  border: 1px solid #e5e7eb;
  overflow: hidden;
}

.minimized-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
  background: #fff;
}

.minimized-title h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #111827;
}

.minimized-controls {
  display: flex;
  align-items: center;
  gap: 30px;
}

.minimized-controls .cursor-pointer {
  color: #6b7280;
  transition: color 0.2s ease;
}

.minimized-controls .cursor-pointer:hover {
  color: #374151;
}

/* Panel Header */
.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
  background: #fff;
  border-radius: 12px 12px 0 0;
}

/* Ensure icons are clickable */
.panel-controls .cursor-pointer,
.minimized-controls .cursor-pointer {
  pointer-events: auto !important;
  cursor: pointer !important;
  z-index: 10;
  position: relative;
}

.panel-controls .cursor-pointer:hover,
.minimized-controls .cursor-pointer:hover {
  opacity: 0.7;
  transform: scale(1.1);
  transition: all 0.2s ease;
}

.panel-title h3 {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: black;
}

.panel-title .back-icon {
  color: #6b7280;
  transition: color 0.2s ease;
  padding: 4px;
  border-radius: 6px;
}

.panel-title .back-icon:hover {
  color: #374151;
  background: #f3f4f6;
}

.panel-title h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #111827;
}

.panel-controls {
  display: flex;
  align-items: center;
  gap: 30px;
}

.panel-controls .cursor-pointer {
  color: #6b7280;
  transition: color 0.2s ease;
}

.panel-controls .cursor-pointer:hover {
  color: #374151;
}

/* Panel Content */
.panel-content {
  padding: 24px;
}

.booking-summary {
  margin-bottom: 24px;
}

.service-tag {
  background: #FBE375;
  color: #2C0146;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 17px;
}

/* Contact Information */
.contact-info {
  margin-bottom: 32px;
}

.info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #f3f4f6;
}

.info-row:last-child {
  border-bottom: none;
}

.duty-assign-section {
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e5e7eb;
  overflow: visible;
}

.duty-assign-section-toggle {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 4px 0;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
}

.duty-assign-section-toggle:focus {
  outline: none;
}

.duty-assign-chevron {
  margin-left: auto;
  flex-shrink: 0;
  color: #374151;
}

.duty-assign-body {
  padding-top: 16px;
  overflow: visible;
}

.duty-assign-collapse-header {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 4px 0;
}

.duty-assign-title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #111827;
}

.duty-assign-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.5rem;
  height: 1.5rem;
  padding: 0 8px;
  border-radius: 999px;
  background: #111827;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}

.duty-assign-saving-label {
  margin-left: auto;
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
}

.duty-assign-editor {
  margin-top: 0;
  margin-bottom: 16px;
  padding-top: 0;
  padding-bottom: 0;
  overflow: visible;
}

.duty-assign-search-row {
  display: flex;
  align-items: stretch;
  gap: 10px;
  width: 100%;
}

.duty-assign-search-input {
  flex: 1;
  min-width: 0;
}

.duty-assign-search-btn {
  flex-shrink: 0;
  min-width: 96px;
}

.duty-assign-results-list {
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  max-height: 280px;
  overflow-y: auto;
}

.duty-assign-result-item {
  display: flex;
  align-items: center;
  gap: 8px;
  border-bottom: 1px solid #f3f4f6;
}

.duty-assign-result-item:last-child {
  border-bottom: none;
}

.duty-assign-result-item--selected {
  background: #f0fdf4;
}

.duty-assign-result-btn {
  flex: 1;
  text-align: left;
  padding: 12px 14px;
  border: none;
  background: transparent;
  cursor: pointer;
}

.duty-assign-result-btn:hover {
  background: #f9fafb;
}

.duty-assign-result-name {
  display: block;
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}

.duty-assign-result-meta {
  display: block;
  font-size: 13px;
  color: #6b7280;
  margin-top: 2px;
}

.duty-assign-result-badge {
  flex-shrink: 0;
  margin-right: 12px;
  font-size: 12px;
  font-weight: 600;
  color: #166534;
}

.duty-assign-results-empty {
  margin: 0;
  padding: 12px 0;
  font-size: 14px;
  color: #6b7280;
}

.duty-assign-select >>> .input-select {
  min-height: 44px;
  font-size: 14px;
  padding-right: 2.5rem;
}

.duty-assign-select >>> .vs-select--options {
  width: 100%;
  max-width: 520px;
}

.duty-assign-user-card {
  padding: 12px 14px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fafafa;
}

.duty-assign-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 4px;
}

.duty-assign-hint {
  margin: 0.5rem 0 0;
  font-size: 0.875rem;
  line-height: 1.4;
}

.duty-assign-remove {
  margin-left: auto;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border: none;
  border-radius: 50%;
  background: #f3f4f6;
  color: #374151;
  cursor: pointer;
}

.duty-assign-remove:hover:not(:disabled) {
  background: #fee2e2;
  color: #b91c1c;
}

.duty-assign-remove:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.status-menu-item--disabled,
.status-menu-item:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  pointer-events: none;
}

.status-menu-item:disabled:hover,
.status-menu-item--disabled:hover {
  background: transparent;
}

.duty-assign-user {
  display: flex;
  align-items: center;
  gap: 14px;
}

.duty-assign-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  background: #f3f4f6;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.duty-assign-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.duty-assign-avatar-fallback {
  font-size: 14px;
  font-weight: 600;
  color: #4b5563;
}

.duty-assign-name {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  color: #111827;
}

.duty-assign-detail {
  margin: 2px 0 0;
  font-size: 15px;
  color: #4b5563;
}

.duty-assign-empty {
  font-size: 15px;
  margin: 0 0 8px;
}

/* Documents Section */
.documents-section {
  margin-top: 12px;
  margin-bottom: 32px;
  padding-top: 12px;
  border-top: 1px solid #f3f4f6;
}

.documents-section h4 {
  margin: 0 0 16px 0;
  font-size: 20px;
  font-weight: 700;
  color: #111827;
}

.documents-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 18px;
}

.document-card {
  /* display: flex; */
  gap: 18px;
  background: #fff;
  border: 1px solid #ededed;
  border-radius: 20px;
  padding: 20px;
  align-items: center;
}

.document-card.status-accepted {
  /* background: #f5fff8; */
  border-color: #ededed;
}

.document-card.status-rejected {
  /* background: #fff6f6; */
  border-color: #ededed;
}

.status-pill.accepted {
  background: #c1f3c1;
}

.status-pill.rejected {
  background: #f3c2c2;
}

.document-media {
  width: 160px;
  height: 160px;
  border-radius: 20px;
  overflow: hidden;
  background: #f7f7f7;
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.document-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.doc-overlay-icons {
  position: absolute;
  right: 8px;
  top: 8px;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  padding: 4px;
  display: flex;
  gap: 6px;
}

.doc-multi-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 8px;
  border-radius: 999px;
  background: #111827;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
}

.document-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.document-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.document-title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #111;
}

/* Pending State: Accept/Reject Buttons */
.document-card-actions,
.document-actions-pending {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 180px;
}

.documents-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
}

.documents-section-header h4 {
  margin: 0;
}

.doc-btn {
  border: none;
  border-radius: 20px;
  width: 140px;
  padding: 19px 0px;
  font-weight: 700;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.doc-btn.accept {
  background: #000;
  color: #fff;
  box-shadow: rgba(17, 17, 17, 0.1) 0px 16px 28px -14px;
}

.disabled-state {
  opacity: 0.6;
  pointer-events: none;
}

.doc-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}


.doc-btn.accept:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.doc-btn.reject {
  background: #f3f4f6;
  color: #111;
}

.doc-btn.undo {
  background: #f3f4f6;
  color: #111;
  padding: 19px 0px;
  width: 140px;
}

/* Accepted State */
.document-status-accepted {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.status-accepted-box {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  background: #9CFF9C;
  color: black;
  width: 140px;
  padding: 19px 0px;
  border-radius: 26px;
  font-weight: 700;
  font-size: 18px;
}

.status-accepted-box svg {
  color: #046c4e;
}

/* Rejected State */
.document-status-rejected {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.status-rejected-box {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #f3c2c2;
  color: #fff;
  padding: 16px 20px;
  border-radius: 20px;
}

.status-rejected-box svg {
  color: #fff;
  flex-shrink: 0;
  margin-top: 2px;
}

.rejected-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.rejected-title {
  font-weight: 600;
  font-size: 15px;
  color: #fff;
}

.rejected-message {
  font-size: 15px;
  color: #fff;
  font-weight: 400;
}

/* New Document Card Styles */
.new-document-card {
  border: 1px solid #e5e7eb;
  background: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0;
  padding: 20px;
}

.new-document-content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
}

.new-doc-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.new-doc-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.new-doc-requirement {
  font-weight: 600;
  font-size: 15px;
  color: #111;
  margin: 0;
}

.new-doc-hint {
  font-size: 15px;
  color: #374151;
  margin: 0;
}

.new-doc-saved-badge {
  font-size: 13px;
  color: #10b981;
  font-weight: 600;
  margin: 4px 0 0 0;
}

.new-doc-edit-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.new-doc-input {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  color: #111;
}

.new-doc-input:focus {
  outline: none;
  border-color: rgba(var(--vs-primary), 1);
}

.new-doc-radio-group {
  display: flex;
  gap: 16px;
  align-items: center;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 15px;
  color: #111;
  font-weight: 500;
}

.radio-input {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.new-doc-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.doc-action-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-size: 15px;
  font-weight: 600;
  color: #2563eb;
  transition: color 0.2s ease;
}

.doc-action-btn:hover {
  color: #1d4ed8;
}

.doc-action-btn.delete {
  color: #dc2626;
}

.doc-action-btn.delete:hover {
  color: #b91c1c;
}

@media (max-width: 1250px) {
  .slot-master-content .vx-row {
    flex-direction: column;
  }

  .booking-list-col,
  .slot-master-col {
    width: 100% !important;
    max-width: 100%;
  }

  .booking-card-container {
    max-height: none;
  }

  /* Keep Slot Master filters above the list when stacked */
  .slot-master-col {
    order: -1;
    margin-bottom: 16px;
  }

  .slots-grid {
    grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  }

  .tab-btn {
    font-size: 16px;
  }

  .detail-panel {
    margin-top: 20px;
    width: min(550px, calc(100vw - 24px));
  }

  .minimized-panel {
    width: min(500px, calc(100vw - 24px));
    right: 12px;
  }
}

@media (max-width: 768px) {
  .slot-master-container {
    max-height: calc(100vh - 100px);
  }

  .slot-master-content .vx-row {
    flex-direction: column;
  }

  .document-card {
    flex-direction: column;
    align-items: flex-start;
  }

  .document-actions,
  .document-status-row {
    width: 100%;
  }

  .doc-btn {
    width: 100%;
  }

  .view_details {
    padding: 14px 16px;
  }

  .booking-info-grid {
    grid-template-columns: 1fr;
  }
}

/* Action Buttons */
.action-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 20px;
  align-items: center;
  margin-top: 24px;
  justify-content: space-between;
  padding: 24px 0px;
  border-top: 1px solid #f3f4f6;
}

.payment-request-btn {
  width: 100%;
  max-width: 343px;
}

.save-changes-container {
  margin-right: auto;
}

.save-changes-container-docs {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

.save-changes-btn {
  background: #10b981 !important;
  color: #fff !important;
  font-weight: 600 !important;
  padding: 12px 24px !important;
  border-radius: 8px !important;
  transition: all 0.2s ease !important;
}

.save-changes-btn:hover {
  background: #059669 !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
}

.action-btn {
  align-items: center;
  gap: 20px;
  padding: 10px 16px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 16px;
  width: 100%;
}

.send-payment-btn {
  background-color: #000000 !important;
  border-color: #000000 !important;
  color: #ffffff !important;
  padding: 16px 24px !important;
  border-radius: 12px !important;
  font-weight: 600 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  width: 100% !important;
}

.send-payment-btn:hover:not(:disabled) {
  background-color: #1a1a1a !important;
  border-color: #1a1a1a !important;
}

.send-payment-btn:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
  background-color: #9ca3af !important;
  border-color: #9ca3af !important;
}

.send-payment-btn .vs-button--text,
.send-payment-btn span {
  color: #ffffff !important;
}

/* Minimized Content */

/* Status dropdown (opens upward like the screenshot) */
.status-action-container {
  position: relative;
}

.status-menu {
  position: absolute;
  left: 0;
  /* align with button left */
  bottom: calc(100% + 12px);
  /* open upward with gap */
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, .1), 0 4px 6px -2px rgba(0, 0, 0, .05);
  min-width: 180px;
  padding: 10px 14px;
  z-index: 20;
}

.status-menu-item {
  width: 100%;
  text-align: left;
  padding: 10px 6px;
  border-radius: 8px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #111827;
  font-weight: 600;
}

.status-menu-item:hover {
  background: #f3f4f6;
}

.minimized-content {
  padding: 16px 20px;
  background: #fff;
}

.minimized-tags {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

/* Responsive */
@media (max-width: 768px) {
  .booking-info-grid {
    grid-template-columns: 1fr;
  }

  .booking-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    padding-bottom: 20px;
  }

  .booking-tags {
    width: 100%;
  }

  .detail-panel {
    width: 95%;
    margin: 20px;
    margin-top: 40px;
  }

  .minimized-panel {
    width: 300px;
    right: 10px;
    bottom: 10px;
  }

  .documents-grid {
    grid-template-columns: 1fr;
  }

  .action-buttons {
    flex-direction: column;
  }

  .info-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .info-label {
    min-width: auto;
  }
}

/* New Booking Modal Styles */
.nb-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 1100;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 20px;
}

.nb-modal {
  width: 520px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
}

.nb-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px;
  border-bottom: 1px solid #e5e7eb;
}

.nb-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
}

.nb-header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.nb-body {
  padding: 18px;
}

.nb-actions {
  margin-top: 16px;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.document-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 6px;
  color: #6b7280;
  padding: 10px;
}

.document-icon {
  font-size: 32px;
}

.document-text {
  font-size: 14px;
  font-weight: 500;
}

/* New Booking Documents Section */
.documents-section-new-booking {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #e5e7eb;
}

.documents-grid-new-booking {
  display: grid;
  grid-template-columns: 1fr;
  gap: 18px;
  margin-bottom: 16px;
}

.document-card-new-booking {
  border: 1px solid #e5e7eb;
  background: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0;
  padding: 20px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.document-card-new-booking:hover {
  border-color: #d1d5db;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.request-doc-btn-new-booking {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f3f4f6;
  border: 1px solid rgb(177, 174, 174);
  border-radius: 12px;
  padding: 26px 28px;
  font-size: 16px;
  font-weight: 700;
  color: #111;
  cursor: pointer;
  transition: all 0.2s ease;
  justify-content: start;
}

.request-doc-btn-new-booking:hover {
  background: #e5e7eb;
}

.request-doc-btn-new-booking svg {
  color: #111;
}

/* CTA Button Styles */
.action-btn-cta {
  width: 100%;
  padding: 16px 24px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
  transition: all 0.2s ease !important;
}

.action-btn-cta:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
}

.action-btn-cta:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Rejection Dialog Styles */
.rejection-dialog-content {
  padding: 8px;
}

.rejection-dialog .vs-textarea {
  width: 100%;
}

.rejection-dialog .vs-textarea textarea {
  min-height: 120px;
  resize: vertical;
}

/* Document Preview Modal Styles — sits on top of View Details */
.doc-preview-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-radius: 20px;
}

.doc-preview-modal {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.3), 0 10px 10px -5px rgba(0, 0, 0, 0.2);
  max-width: min(920px, 100%);
  max-height: 90%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.doc-preview-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px;
  border-bottom: 1px solid #e5e7eb;
  background: #fff;
  border-radius: 12px 12px 0 0;
}

.doc-preview-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #111827;
}

.doc-preview-header .cursor-pointer {
  color: #6b7280;
  transition: color 0.2s ease;
}

.doc-preview-header .cursor-pointer:hover {
  color: #374151;
}

.doc-preview-content {
  padding: 16px;
  overflow-y: auto;
  max-height: calc(100% - 72px);
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
}

.doc-preview-image-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.doc-preview-image {
  max-width: 100%;
  max-height: min(520px, calc(100vh - 280px));
  height: auto;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  object-fit: contain;
}


/* Tooltip Styles */
.tooltip-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.tooltip-text {
  visibility: hidden;
  opacity: 0;
  background-color: #1f2937;
  color: #ffffff;
  text-align: center;
  border-radius: 6px;
  padding: 8px 12px;
  position: absolute;
  z-index: 1000;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  font-size: 13px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: opacity 0.3s ease, visibility 0.3s ease;
  pointer-events: none;
}

.tooltip-text::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #1f2937 transparent transparent transparent;
}

.tooltip-wrapper:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}

/* For better positioning on smaller screens */
@media (max-width: 768px) {
  .tooltip-text {
    white-space: normal;
    max-width: 250px;
    white-space: normal;
    word-wrap: break-word;
  }
}


@media (max-width: 1200px) {
  .doc-preview-modal {
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  .doc-preview-modal {
    max-width: 100%;
    max-height: 95%;
  }

  .doc-preview-content {
    padding: 12px;
  }

  .doc-preview-image {
    max-height: min(420px, calc(100vh - 260px));
  }
}
</style>
